/* ============================================================================
   AP Uniforms V2 — Theme JavaScript
   Vanilla JS, ES2020+, no dependencies
   ========================================================================== */

/* #454 — identify product options by role in English or French. On the French
   CA storefront Shopify serves translated option names (Couleur, Taille...). */
function apOptionRole(name) {
  var n = String(name || '').trim().toLowerCase();
  if (['color', 'colour', 'couleur', 'couleurs', 'coloris'].indexOf(n) !== -1) return 'color';
  if (['size', 'taille', 'tailles', 'grandeur', 'pointure'].indexOf(n) !== -1) return 'size';
  if (['subsize', 'length', 'longueur', 'sous-taille', 'sous taille', 'sous-dimension', 'sous-dimensionner', 'coupe', 'inseam', 'entrejambe'].indexOf(n) !== -1) return 'subsize';
  return '';
}
function apOptionIndex(names, role) {
  for (var i = 0; i < (names || []).length; i++) if (apOptionRole(names[i]) === role) return i;
  return -1;
}


document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initMobileMenu();
  initMegaMenu();
  initCartCount();
  initCartDrawer();
  initAnnouncementBar();
  initReviewsCarousel();
  initProductCardSwatches();
  initCollectionColorMatch();
  initCollectionFilters();
  initSizeChartModal();
  initShopTheLook();
  initStickyATC();
  initGA4Events();
  initSubsizeSiblingRow();
});

/* ============================================================================
   CBI subsize-split (Option D): linked-sibling Subsize row
   ----------------------------------------------------------------------------
   On PDP load:
     - If URL has ?color=X, click the matching color swatch (case-insensitive).
       No-op if no match (e.g. sibling product doesn't carry that color).
   On sibling-link click:
     - Append ?color=<currently-selected> to the outbound URL so the sibling
       PDP lands with color preserved.
   Inert on products without [data-subsize-linked].
   ========================================================================== */
function initSubsizeSiblingRow() {
  var pm = null;
  try { pm = new URLSearchParams(window.location.search); } catch (e) {}

  // Inbound: capture ?color=X and click the matching swatch
  try {
    var colorParam = pm && pm.get('color');
    if (colorParam) {
      var swatches = document.querySelectorAll('.s-pdp__color-swatch[data-option-value]');
      var wanted = decodeURIComponent(colorParam).toUpperCase();
      var matched = null;
      for (var i = 0; i < swatches.length; i++) {
        var v = (swatches[i].getAttribute('data-option-value') || '').toUpperCase();
        if (v === wanted) { matched = swatches[i]; break; }
      }
      if (matched && !matched.classList.contains('is-selected')) {
        matched.click();
      }
    }
  } catch (e) { /* no-op — leave default-selected color */ }

  // Inbound: capture ?size=X and click the matching size button IF that size exists in this subsize
  // (the destination subsize may not carry every size — e.g. Tall has only XS-2XL on WW110).
  // If size doesn't exist or is .is-unavailable, leave default size selected.
  try {
    var sizeParam = pm && pm.get('size');
    if (sizeParam) {
      var wantedSize = decodeURIComponent(sizeParam).toUpperCase();
      // Scope to the Size option row (not Subsize / Color rows)
      var sizeRow = Array.from(document.querySelectorAll('.s-pdp__option'))
        .find(function(el) {
          var name = el.querySelector('.s-pdp__option-name');
          return name && apOptionRole(name.textContent) === 'size';
        });
      if (sizeRow) {
        var sizeBtns = sizeRow.querySelectorAll('.s-pdp__size-btn[data-option-value]');
        for (var si = 0; si < sizeBtns.length; si++) {
          var sv = (sizeBtns[si].getAttribute('data-option-value') || '').toUpperCase();
          if (sv === wantedSize &&
              !sizeBtns[si].classList.contains('is-unavailable') &&
              !sizeBtns[si].disabled) {
            sizeBtns[si].click();
            break;
          }
        }
      }
    }
  } catch (e) { /* no-op — leave default size selected */ }

  // Inbound: if arrived from a sibling-link click, scroll the subsize row back into view
  // so user doesn't get bounced to the top of the new product page. Use rAF x2 to wait
  // for layout to settle after the color swap above (which can re-size the gallery image).
  try {
    if (sessionStorage.getItem('pdp_scroll_to_subsize')) {
      sessionStorage.removeItem('pdp_scroll_to_subsize');
      var row = document.querySelector('[data-subsize-linked]');
      if (row) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            row.scrollIntoView({ block: 'center' });
          });
        });
      }
    }
  } catch (e) { /* sessionStorage may be unavailable in private windows */ }

  // Outbound: sibling link click preserves current color AND size via URL params + sets scroll-restore flag.
  // Helper: read currently-selected Color + Size from the PDP and apply to a URL.
  function applyCurrentSelectionToUrl(baseHref) {
    var u = new URL(baseHref, location.origin);
    try {
      var selColor = document.querySelector('.s-pdp__color-swatch.is-selected');
      if (selColor && selColor.dataset.optionValue) u.searchParams.set('color', selColor.dataset.optionValue);
    } catch (e) {}
    try {
      var sizeRow = Array.from(document.querySelectorAll('.s-pdp__option'))
        .find(function(el) {
          var name = el.querySelector('.s-pdp__option-name');
          return name && apOptionRole(name.textContent) === 'size';
        });
      if (sizeRow) {
        var selSize = sizeRow.querySelector('.s-pdp__size-btn.is-selected[data-option-value]');
        if (selSize && selSize.dataset.optionValue) u.searchParams.set('size', selSize.dataset.optionValue);
      }
    } catch (e) {}
    return u.toString();
  }
  var siblingLinks = document.querySelectorAll('[data-subsize-link]');

  // === Speculation Rules: prerender sibling URLs in a background frame ===
  // Stronger than <link rel="prefetch">. Chrome ACTUALLY renders the page in a
  // hidden tab, so activation on click is instant — no parse, no paint, no flash.
  // Supported in Chrome 121+ via HTMLScriptElement.supports('speculationrules').
  // Other browsers ignore the <script> tag and fall back to normal navigation.
  var speculationRulesScript = null;
  function applySpeculationRules() {
    if (siblingLinks.length === 0) return;
    if (typeof HTMLScriptElement === 'undefined' ||
        typeof HTMLScriptElement.supports !== 'function' ||
        !HTMLScriptElement.supports('speculationrules')) return;
    var urls = Array.prototype.map.call(siblingLinks, function(a) {
      return applyCurrentSelectionToUrl(a.href);
    });
    // Tear down the previous rules block if we're re-applying
    if (speculationRulesScript && speculationRulesScript.parentNode) {
      speculationRulesScript.parentNode.removeChild(speculationRulesScript);
    }
    var rules = {
      prerender: [{
        source: 'list',
        urls: urls,
        // 'moderate' eagerness: starts prerender on hover/touchstart, not immediately on load,
        // so we don't waste CPU/bandwidth on visitors who never click a sibling.
        eagerness: 'moderate'
      }]
    };
    speculationRulesScript = document.createElement('script');
    speculationRulesScript.type = 'speculationrules';
    speculationRulesScript.textContent = JSON.stringify(rules);
    document.head.appendChild(speculationRulesScript);
  }

  // Re-apply speculation rules whenever color or size selection changes
  // (so the prerendered URL matches what click would actually navigate to)
  var optionContainer = document.querySelector('.s-pdp__color-swatches')?.parentElement;
  function reapplyOnSelection() { applySpeculationRules(); }
  document.addEventListener('click', function(e) {
    if (e.target.closest && (e.target.closest('.s-pdp__color-swatch') || e.target.closest('.s-pdp__size-btn'))) {
      setTimeout(reapplyOnSelection, 50);
    }
  });

  siblingLinks.forEach(function(a) {
    a.addEventListener('click', function() {
      try { a.href = applyCurrentSelectionToUrl(a.href); } catch (e) {}
      try { sessionStorage.setItem('pdp_scroll_to_subsize', '1'); } catch (e) {}
    });
  });

  // Apply initial speculation rules after a short delay (so initial color/size selection settles)
  setTimeout(applySpeculationRules, 500);
}

/* ----------------------------------------------------------------------------
   GA4 Ecommerce Events (#198)
   Emits view_item, add_to_cart, view_cart, begin_checkout.
   Shopify handles `purchase` natively at checkout — don't duplicate.
   -------------------------------------------------------------------------- */

function gaTrack(eventName, params) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (_err) { /* analytics must never break the UI */ }
}

function parsePrice(input) {
  if (input == null) return 0;
  if (typeof input === 'number') return input > 1000 ? input / 100 : input;
  var s = String(input).replace(/[^\d.]/g, '');
  var n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

function buildVariantLabel(color, size, subsize) {
  return [color, size, subsize].filter(Boolean).join(' / ');
}

function gaItemFromProductData(productData) {
  if (!productData) return null;
  var price = parsePrice(productData.price);
  var jsonLd = readProductJsonLd();
  var brand = jsonLd ? ((jsonLd.brand && (jsonLd.brand.name || jsonLd.brand)) || '') : '';
  return {
    item_id: String(productData.productId || ''),
    item_name: productData.title || '',
    item_brand: brand,
    item_variant: buildVariantLabel(productData.color, productData.size, productData.subsize),
    price: price,
    quantity: 1
  };
}

function readProductJsonLd() {
  try {
    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < nodes.length; i++) {
      var data = JSON.parse(nodes[i].textContent);
      var candidates = data['@graph'] || [data];
      for (var j = 0; j < candidates.length; j++) {
        if (candidates[j]['@type'] === 'Product') return candidates[j];
      }
    }
  } catch (_err) { /* malformed JSON-LD — fall through */ }
  return null;
}

function emitViewItem() {
  if (!/^\/products\//.test(location.pathname)) return;
  var h1 = document.querySelector('.s-pdp__title, h1');
  var form = document.querySelector('[data-product-form]');
  if (!form || !h1) return;
  var priceEl = document.querySelector('[data-atc-price]');
  var price = parsePrice(priceEl ? priceEl.textContent : '');
  var jsonLd = readProductJsonLd();
  var brand = '';
  var category = '';
  if (jsonLd) {
    brand = (jsonLd.brand && (jsonLd.brand.name || jsonLd.brand)) || '';
    category = jsonLd.category || '';
  }
  var item = {
    item_id: form.dataset.productId || '',
    item_name: h1.textContent.trim(),
    item_brand: brand,
    item_category: category,
    price: price,
    quantity: 1
  };
  gaTrack('view_item', { currency: 'USD', value: price, items: [item] });
}

function emitViewCart() {
  if (location.pathname !== '/cart') return;
  fetch('/cart.js', { credentials: 'include' })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var items = (cart.items || []).map(function (i) {
        return {
          item_id: String(i.product_id || ''),
          item_name: i.product_title || i.title || '',
          item_brand: i.vendor || '',
          item_variant: i.variant_title || '',
          price: parsePrice(i.final_price || i.price),
          quantity: i.quantity || 1
        };
      });
      gaTrack('view_cart', {
        currency: (cart.currency || 'USD'),
        value: parsePrice(cart.total_price),
        items: items
      });
    })
    .catch(function () { /* silent */ });
}

function bindBeginCheckout() {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
    if (!link) return;
    fetch('/cart.js', { credentials: 'include' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) {
          return {
            item_id: String(i.product_id || ''),
            item_name: i.product_title || i.title || '',
            item_brand: i.vendor || '',
            item_variant: i.variant_title || '',
            price: parsePrice(i.final_price || i.price),
            quantity: i.quantity || 1
          };
        });
        gaTrack('begin_checkout', {
          currency: (cart.currency || 'USD'),
          value: parsePrice(cart.total_price),
          items: items
        });
      })
      .catch(function () { /* silent */ });
  }, true); // capture — fires before the navigation
}

function initGA4Events() {
  emitViewItem();
  emitViewCart();
  bindBeginCheckout();
}

/* ----------------------------------------------------------------------------
   Sticky Add to Cart (Mobile)
   -------------------------------------------------------------------------- */

function initStickyATC() {
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var realBtn = document.querySelector('[data-add-to-cart]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAddBtn = document.querySelector('[data-sticky-add]');
  if (!stickyBar || !realBtn) return;

  // IntersectionObserver — show sticky when real ATC button scrolls out of view
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var cartDrawerOpen = document.querySelector('[data-cart-drawer].is-open');
      if (!entry.isIntersecting && !cartDrawerOpen) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });
  observer.observe(realBtn);

  // Click sticky button → click the real ATC button (triggers form submit + cart drawer)
  stickyAddBtn.addEventListener('click', function() {
    if (!stickyAddBtn.disabled) {
      realBtn.click();
    }
  });

  // Sync price + sold-out state via MutationObserver on real ATC button
  var atcObserver = new MutationObserver(function() {
    var priceEl = document.querySelector('[data-atc-price]');
    if (priceEl) {
      stickyPrice.textContent = priceEl.textContent;
      stickyAddBtn.disabled = false;
      stickyAddBtn.textContent = 'ADD TO BAG';
    } else {
      stickyPrice.textContent = '';
      stickyAddBtn.disabled = true;
      stickyAddBtn.textContent = 'SOLD OUT';
    }
  });
  atcObserver.observe(realBtn, { childList: true, subtree: true, characterData: true });

  // Hide when cart drawer opens
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    var drawerObserver = new MutationObserver(function() {
      if (cartDrawer.classList.contains('is-open')) {
        stickyBar.classList.remove('is-visible');
      }
    });
    drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
}

/* ----------------------------------------------------------------------------
   Header Scroll Shadow
   -------------------------------------------------------------------------- */

function initHeaderScroll() {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  let lastScrollY = 0;
  let ticking = false;

  window.addEventListener('scroll', () => {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        header.classList.toggle('scrolled', lastScrollY > 0);
        ticking = false;
      });
      ticking = true;
    }
  });
}

/* ----------------------------------------------------------------------------
   Mobile Menu Toggle
   -------------------------------------------------------------------------- */

function initMobileMenu() {
  const toggles = document.querySelectorAll('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-mobile-overlay]');
  if (!toggles.length || !drawer) return;

  function openMenu() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
  }

  toggles.forEach(t => {
    t.addEventListener('click', () => {
      const isOpen = drawer.classList.contains('is-open');
      isOpen ? closeMenu() : openMenu();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeMenu();
      toggles[0].focus();
    }
  });
}

/* ----------------------------------------------------------------------------
   Mega Menu (Desktop Hover)
   -------------------------------------------------------------------------- */

function initMegaMenu() {
  const menuItems = document.querySelectorAll('[data-mega-trigger]');
  let closeTimeout = null;

  menuItems.forEach((trigger) => {
    const megaMenu = trigger.nextElementSibling;
    if (!megaMenu || !megaMenu.hasAttribute('data-mega-content')) return;

    trigger.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      closeAllMegas();
      megaMenu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    });

    trigger.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        megaMenu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 200);
    });

    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
    });

    megaMenu.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        megaMenu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 200);
    });

    // Keyboard: ESC closes mega menu
    megaMenu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        megaMenu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  function closeAllMegas() {
    document.querySelectorAll('[data-mega-content].is-open').forEach((m) => {
      m.classList.remove('is-open');
      const trigger = m.previousElementSibling;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
}

/* ----------------------------------------------------------------------------
   Cart Count Badge
   -------------------------------------------------------------------------- */

function initCartCount() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      updateCartCount(cart.item_count);
    })
    .catch(() => { console.warn('Cart count unavailable'); });
}

function updateCartCount(count) {
  const badges = document.querySelectorAll('[data-cart-count]');
  badges.forEach((badge) => {
    badge.textContent = count;
    badge.style.display = count > 0 ? '' : 'none';
  });
}

/* ----------------------------------------------------------------------------
   Shared Helpers — Gender / Collection / Type (used by Cart Drawer & Shop the Look)
   -------------------------------------------------------------------------- */

function getProductGender() {
  const tagsEl = document.querySelector('[data-product-tags]');
  if (!tagsEl) return '';
  let tags = [];
  try { tags = JSON.parse(tagsEl.textContent).map(t => t.toLowerCase()); } catch(e) { return ''; }
  if (tags.includes('women') || tags.includes("women's")) return 'women';
  if (tags.includes('men') || tags.includes("men's")) return 'men';
  if (tags.includes('unisex')) return 'unisex';
  return '';
}

function getProductCollection() {
  const tagsEl = document.querySelector('[data-product-tags]');
  if (!tagsEl) return '';
  let tags = [];
  try { tags = JSON.parse(tagsEl.textContent); } catch(e) { return ''; }
  return getCollectionFromTags(tags);
}

function getGenderFromTags(tags) {
  if (!tags || !tags.length) return '';
  const lower = tags.map(t => t.toLowerCase());
  if (lower.includes('women') || lower.includes("women's")) return 'women';
  if (lower.includes('men') || lower.includes("men's")) return 'men';
  if (lower.includes('unisex')) return 'unisex';
  return '';
}

function getCollectionFromTags(tags) {
  if (!tags || !tags.length) return '';
  const colTag = tags.find(t => t.startsWith('COLLECTION:'));
  return colTag ? colTag.replace('COLLECTION:', '').toLowerCase() : '';
}

function getCollectionTagRaw(tags) {
  if (!tags || !tags.length) return '';
  var colTag = (tags).find(function(t) { return t.indexOf('COLLECTION:') === 0; });
  return colTag ? colTag.replace('COLLECTION:', '') : '';
}

function isGenderCompatible(g1, g2) {
  if (!g1 || !g2) return true;
  if (g1 === 'unisex' || g2 === 'unisex') return true;
  return g1 === g2;
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

/* ----------------------------------------------------------------------------
   Cart Drawer ("Added to Bag")
   -------------------------------------------------------------------------- */

function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');
  const closeBtn = document.querySelector('[data-cart-drawer-close]');
  if (!drawer || !overlay) return;

  const itemEl = drawer.querySelector('[data-cart-drawer-item]');
  const imgEl = drawer.querySelector('[data-cart-drawer-item-image]');
  const titleEl = drawer.querySelector('[data-cart-drawer-item-title]');
  const colorEl = drawer.querySelector('[data-cart-drawer-item-color]');
  const sizeEl = drawer.querySelector('[data-cart-drawer-item-size]');
  const subsizeEl = drawer.querySelector('[data-cart-drawer-item-subsize]');
  const priceEl = drawer.querySelector('[data-cart-drawer-item-price]');
  const countEl = drawer.querySelector('[data-cart-drawer-count]');
  const pluralEl = drawer.querySelector('[data-cart-drawer-count-plural]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  const recsSection = drawer.querySelector('[data-cart-drawer-recs-section]');
  const recsContainer = drawer.querySelector('[data-cart-drawer-recs]');
  const errorEl = drawer.querySelector('[data-cart-drawer-error]');
  const errorMsgEl = drawer.querySelector('[data-cart-drawer-error-msg]');

  let isAdding = false;
  let lastSelectedColor = '';

  const formatMoney = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  // --- Open / Close ---

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // --- Populate item details ---

  function setDrawerItem({ image, title, color, size, subsize, price }) {
    if (imgEl) {
      imgEl.src = image || '';
      imgEl.alt = title || '';
      // Fallback for missing image
      if (!image) imgEl.style.display = 'none';
      else imgEl.style.display = '';
    }
    if (titleEl) titleEl.textContent = title || '';
    if (colorEl) {
      if (color) {
        colorEl.innerHTML = 'Color: <strong>' + escapeHtml(color) + '</strong>';
        colorEl.style.display = '';
      } else {
        colorEl.style.display = 'none';
      }
    }
    if (sizeEl) {
      if (size) {
        sizeEl.innerHTML = 'Size: <strong>' + escapeHtml(size) + '</strong>';
        sizeEl.style.display = '';
      } else {
        sizeEl.style.display = 'none';
      }
    }
    if (subsizeEl) {
      if (subsize) {
        subsizeEl.innerHTML = 'Subsize: <strong>' + escapeHtml(subsize) + '</strong>';
        subsizeEl.style.display = '';
      } else {
        subsizeEl.style.display = 'none';
      }
    }
    if (priceEl) priceEl.textContent = price || '';
    if (itemEl) itemEl.style.display = '';
    if (errorEl) errorEl.style.display = 'none';
  }

  // --- Update subtotal ---

  function setDrawerSubtotal(itemCount, totalPriceCents) {
    if (countEl) countEl.textContent = itemCount;
    if (pluralEl) pluralEl.style.display = itemCount === 1 ? 'none' : '';
    if (subtotalEl) subtotalEl.textContent = formatMoney.format(totalPriceCents / 100);
  }

  // --- Show error ---

  function showError(msg) {
    if (errorEl && errorMsgEl) {
      errorMsgEl.textContent = msg;
      errorEl.style.display = '';
    }
    if (itemEl) itemEl.style.display = 'none';
  }

  // --- Fetch and render recommendations ---

  // Detect product type from tags embedded on the page
  function getProductType() {
    const tagsEl = document.querySelector('[data-product-tags]');
    if (!tagsEl) return '';
    let tags = [];
    try { tags = JSON.parse(tagsEl.textContent).map(t => t.toLowerCase()); } catch(e) { return ''; }
    if (tags.some(t => t === 'top' || t === 'tops' || t === 'tunic' || t === 'shirt')) return 'top';
    if (tags.some(t => t === 'pant' || t === 'pants' || t === 'jogger' || t === 'joggers')) return 'pant';
    if (tags.some(t => t === 'jacket' || t === 'jackets')) return 'jacket';
    if (tags.some(t => t === 'lab coat' || t === 'lab coats')) return 'lab coat';
    return '';
  }

  // Categorize a product by its tags
  function getTypeFromTags(tags) {
    if (!tags || !tags.length) return '';
    const lower = tags.map(t => t.toLowerCase());
    if (lower.includes('jacket') || lower.includes('jackets')) return 'jacket';
    if (lower.includes('pant') || lower.includes('pants') || lower.includes('jogger') || lower.includes('joggers')) return 'pant';
    if (lower.includes('top') || lower.includes('tops') || lower.includes('tunic') || lower.includes('shirt')) return 'top';
    if (lower.includes('lab coat') || lower.includes('lab coats')) return 'lab coat';
    return '';
  }

  function loadRecommendations(productId, selectedColor) {
    lastSelectedColor = selectedColor || '';
    if (!recsSection || !recsContainer || !productId) {
      if (recsSection) recsSection.style.display = 'none';
      return;
    }

    const currentType = getProductType();
    const currentGender = getProductGender();
    const currentCollection = getProductCollection();
    const currentVendor = (function() {
      var el = document.querySelector('.s-pdp__vendor');
      return el ? el.textContent.trim().split('\n')[0].trim().toLowerCase() : '';
    })();

    // Helper: get complementary match types for a given product type
    function getMatchTypes(type) {
      if (type === 'top') return ['pant', 'jogger', 'jacket'];
      if (type === 'pant') return ['top', 'tunic', 'shirt', 'jacket'];
      if (type === 'jacket') return ['top', 'tunic', 'shirt', 'pant', 'jogger'];
      return [];
    }

    // Helper: check if product has a matching color option (#283: family-aware).
    // Substring/exact match wins first; same-family match is a soft fallback so
    // products with related colors (e.g., Pewter for Grey) outrank truly off-color
    // products in the 8-tier scoring waterfall below.
    function hasColorMatch(product, color) {
      if (!color) return false;
      var colorUpper = color.toUpperCase();
      var srcFam = (typeof window !== 'undefined' && window.AP_COLOR_MAP && window.AP_COLOR_MAP.getFamily)
        ? window.AP_COLOR_MAP.getFamily(color) : null;
      return (product.options || []).some(function(o) {
        if (apOptionRole(o.name) !== 'color') return false;
        return o.values.some(function(v) {
          var vUpper = v.toUpperCase();
          if (vUpper.includes(colorUpper) || colorUpper.includes(vUpper)) return true;
          if (srcFam && window.AP_COLOR_MAP.getFamily(v) === srcFam) return true;
          return false;
        });
      });
    }

    // 8-tier scoring mirroring Shop the Look Liquid waterfall (#162).
    // Hard filters: gender compatibility + complementary type.
    // Soft ranking: color > brand > collection > gender tier.
    function scoreCandidate(product) {
      var recGender = getGenderFromTags(product.tags || []);
      if (!isGenderCompatible(currentGender, recGender)) return -1;

      var matchTypes = getMatchTypes(currentType);
      if (matchTypes.length > 0) {
        var recType = getTypeFromTags(product.tags || []);
        if (matchTypes.indexOf(recType) === -1) return -1;
      }

      var colorMatch = hasColorMatch(product, selectedColor);
      var brandMatch = (product.vendor || '').toLowerCase().trim() === currentVendor;
      var recCollection = getCollectionFromTags(product.tags || []);
      var collectionMatch = currentCollection && recCollection && recCollection === currentCollection;
      var isPrimaryGender = recGender === currentGender;

      if (isPrimaryGender || !currentGender) {
        if (colorMatch && brandMatch && collectionMatch) return 1;
        if (colorMatch && brandMatch) return 2;
        if (colorMatch) return 3;
        return 4;
      } else {
        if (colorMatch && brandMatch && collectionMatch) return 5;
        if (colorMatch && brandMatch) return 6;
        if (colorMatch) return 7;
        return 8;
      }
    }

    // Tiebreaker: primary opposite type first (pants before jackets for tops, etc.)
    function getTypePriority(product) {
      var recType = getTypeFromTags(product.tags || []);
      if (currentType === 'top') return (recType === 'pant' || recType === 'jogger') ? 0 : 1;
      if (currentType === 'pant') return (recType === 'top' || recType === 'tunic' || recType === 'shirt') ? 0 : 1;
      if (currentType === 'jacket') return (recType === 'top' || recType === 'tunic' || recType === 'shirt') ? 0 : 1;
      return 1;
    }

    // Score, filter, and rank candidates using the 8-tier waterfall
    function rankCandidates(products) {
      return products
        .map(function(p) { return { product: p, tier: scoreCandidate(p), typePri: getTypePriority(p) }; })
        .filter(function(s) { return s.tier > 0; })
        .sort(function(a, b) { return (a.tier - b.tier) || (a.typePri - b.typePri); })
        .map(function(s) { return s.product; });
    }

    // Tier 3: fetch from collection(s), score with 8-tier waterfall
    function fetchCollectionFallback() {
      var matchTypes = getMatchTypes(currentType);
      if (matchTypes.length === 0) { recsSection.style.display = 'none'; return; }

      // Try source collection first, then gender collection as fallback
      var collHandles = [];
      var srcHandle = currentCollection ? currentCollection.replace(/\s+/g, '-') : '';
      if (srcHandle) collHandles.push(srcHandle);
      // Gender collection fallback (wider pool)
      var genderHandle = currentGender === 'women' ? 'womens-scrubs' : currentGender === 'men' ? 'mens-scrubs' : '';
      if (genderHandle && genderHandle !== srcHandle) collHandles.push(genderHandle);
      console.log('[Recs] Tier 3: collections=' + JSON.stringify(collHandles) + ', type="' + currentType + '"');
      if (collHandles.length === 0) { recsSection.style.display = 'none'; return; }

      // Fetch collections sequentially, merge results
      var allProducts = [];
      var seenIds = new Set();
      function fetchNext(idx) {
        if (idx >= collHandles.length) {
          var ranked = rankCandidates(allProducts);
          console.log('[Recs] Tier 3: ' + ranked.length + ' complementary products found');
          if (ranked.length > 0) { renderRecs(ranked.slice(0, 6)); }
          else { recsSection.style.display = 'none'; }
          return;
        }
        fetch('/collections/' + collHandles[idx] + '/products.json?limit=50')
          .then(function(r) { return r.json(); })
          .then(function(colData) {
            (colData.products || []).forEach(function(p) {
              if (p.id === parseInt(productId)) return;
              if (seenIds.has(p.id)) return;
              seenIds.add(p.id);
              var img = p.featured_image;
              var featuredSrc = img ? (typeof img === 'string' ? img : img.src || '') : (p.images && p.images[0] ? p.images[0].src : '');
              allProducts.push({
                id: p.id, title: p.title, handle: p.handle,
                url: '/products/' + p.handle, vendor: p.vendor,
                tags: p.tags || [],
                price: Math.round(parseFloat(p.variants && p.variants[0] ? p.variants[0].price : '0') * 100),
                featured_image: featuredSrc,
                images: (p.images || []).map(function(i) {
                  return { src: typeof i === 'string' ? i : i.src, alt: typeof i === 'string' ? '' : (i.alt || '') };
                }),
                options: p.options || [],
                variants: (p.variants || []).map(function(v) {
                  return {
                    id: v.id,
                    price: Math.round(parseFloat(v.price) * 100),
                    compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
                    option1: v.option1 || '',
                    available: v.available
                  };
                })
              });
            });
            fetchNext(idx + 1);
          })
          .catch(function(err) {
            console.warn('[Recs] Tier 3 fetch failed for /collections/' + collHandles[idx], err);
            fetchNext(idx + 1);
          });
      }
      fetchNext(0);
    }

    // Try complementary first, fallback to related, then collection.
    // All tiers use the 8-tier waterfall scoring (#162).
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var ranked = rankCandidates(data.products || []);
        console.log('[Recs] Tier 1 (complementary): ' + (data.products || []).length + ' raw, ' + ranked.length + ' after 8-tier scoring');
        if (ranked.length >= 2) {
          renderRecs(ranked.slice(0, 6));
        } else {
          // Fallback: fetch related, merge with Tier 1, re-score
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
            .then(function(res) { return res.json(); })
            .then(function(data2) {
              console.log('[Recs] Tier 2 (related): ' + (data2.products || []).length + ' raw');
              var merged = (data.products || []).concat(data2.products || []);
              var seen = new Set();
              merged = merged.filter(function(p) {
                if (seen.has(p.id)) return false;
                seen.add(p.id);
                return true;
              });
              var ranked2 = rankCandidates(merged);
              console.log('[Recs] Tier 2: ' + ranked2.length + ' after 8-tier scoring');
              if (ranked2.length >= 2) {
                renderRecs(ranked2.slice(0, 6));
              } else {
                console.log('[Recs] Tier 2: only ' + ranked2.length + ', trying Tier 3 collection fallback');
                fetchCollectionFallback();
              }
            });
        }
      })
      .catch(function(err) {
        console.warn('[Recs] Tier 1 fetch failed, trying collection fallback', err);
        fetchCollectionFallback();
      });
  }

  // Score a product's color match against lastSelectedColor.
  // Delegates to AP_COLOR_MATCH.colorMatchTier() — shared with look-color-sync.js.
  // See #141 (regression), #227 (refactor).
  function colorMatchTier(product) {
    if (!lastSelectedColor) return 0; // no color filter — everything matches
    return AP_COLOR_MATCH.colorMatchTier(product.variants || [], lastSelectedColor);
  }

  function renderRecs(products) {
    // Fetch full product JSON to get image objects with alt text for color matching.
    // The Recommendations API (Tiers 1-2) returns images as plain URL strings
    // without .alt — the color-match loop in renderRecCard needs .alt to work.
    // Tier 3 (collection fallback) already provides { src, alt } objects. #141
    var enrichTasks = products.map(function(p) {
      // Skip enrichment only when images have *populated* alt text — shape alone
      // is insufficient. Tier 3 (collection fallback) pre-shapes images as
      // {src, alt:''} but alt is empty because /collections/*/products.json
      // returns null alt. Without real alts, findColorMatchedImage can't resolve
      // a color-matched image and falls through to featured_image (wrong color).
      // See #228.
      if (p.images && p.images.length > 0 && typeof p.images[0] !== 'string' &&
          p.images[0].alt && p.images[0].alt.length > 0) {
        return Promise.resolve(p);
      }
      var handle = p.handle || (p.url || '').replace('/products/', '').split('?')[0];
      if (!handle) return Promise.resolve(p);
      return fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          p.images = data.product.images || p.images;
          // Also enrich variants if the enriched data has more detail (e.g. option1)
          if (data.product.variants && data.product.variants.length > 0) {
            p.variants = data.product.variants.map(function(v) {
              return {
                id: v.id,
                price: Math.round(parseFloat(v.price) * 100),
                compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
                option1: v.option1 || '',
                available: v.available
              };
            });
          }
          return p;
        })
        .catch(function() { return p; }); // graceful fallback to original data
    });

    Promise.all(enrichTasks).then(function(enrichedProducts) {
      // Post-enrichment: sort by color match so color-matched recs come first.
      // Mirrors reorderLookCards() in look-color-sync.js. See #141 (regression).
      var scored = enrichedProducts.map(function(p, i) {
        return { product: p, tier: colorMatchTier(p), idx: i };
      });
      scored.sort(function(a, b) {
        if (a.tier !== b.tier) return a.tier - b.tier;
        return a.idx - b.idx; // stable sort within same tier
      });

      // If we have ≥2 color-matched products (tier 0), drop non-matching (tier 2).
      // If <2 matches, keep everything — fallback-to-Black is better than empty.
      var tier0Count = scored.filter(function(s) { return s.tier === 0; }).length;
      var filtered = tier0Count >= 2
        ? scored.filter(function(s) { return s.tier < 2; })
        : scored;

      var sortedProducts = filtered.map(function(s) { return s.product; });
      console.log('[Recs] Color sort: ' + tier0Count + ' color-matched, ' +
        (enrichedProducts.length - tier0Count) + ' fallback, showing ' + sortedProducts.length);

      recsContainer.innerHTML = sortedProducts.map(renderRecCard).join('');
      recsSection.style.display = '';
      if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) {
        AP_COLOR_MAP.applyAll();
      }
    });
  }

  // Scroll arrows for recs
  const prevArrow = drawer.querySelector('[data-recs-prev]');
  const nextArrow = drawer.querySelector('[data-recs-next]');
  if (prevArrow && recsContainer) {
    prevArrow.addEventListener('click', () => {
      recsContainer.scrollBy({ left: -170, behavior: 'smooth' });
    });
  }
  if (nextArrow && recsContainer) {
    nextArrow.addEventListener('click', () => {
      recsContainer.scrollBy({ left: 170, behavior: 'smooth' });
    });
  }

  // Refactored in #227: uses AP_COLOR_MATCH shared utility for color matching.
  // Price unit: v.price / 100 (Recommendations API returns cents).
  function renderRecCard(product) {
    var imgSrc = product.featured_image || '';
    var colorUpper = lastSelectedColor ? lastSelectedColor.toUpperCase() : '';

    // Color-match: find image via variant→image link first, alt-text fallback (#279)
    if (colorUpper && product.images) {
      var matchedImg = AP_COLOR_MATCH.findColorMatchedImage(product.images, colorUpper, true, product.variants);
      if (matchedImg) imgSrc = matchedImg.src;
    }

    // 3-step variant selection (#283 follow-up to #282): exact → same-family → first-available.
    // Image is re-matched to the chosen variant's color at the end so href, price,
    // and image always agree. See #76, #141, #227, #282.
    var matched = null;

    // Step 1: exact color match
    if (colorUpper && product.variants) {
      var matchedV = AP_COLOR_MATCH.findColorMatchedVariant(product.variants, colorUpper);
      if (matchedV) {
        matched = { price: matchedV.price / 100, id: matchedV.id, color: matchedV.option1 };
      }
    }

    // Step 2: same-family match (#283 — Grey → Pewter, Pacific Blue → Royal Blue, etc.)
    if (!matched && colorUpper && product.variants) {
      var familyV = AP_COLOR_MATCH.findFamilyMatchedVariant(product.variants, colorUpper);
      if (familyV) {
        matched = { price: familyV.price / 100, id: familyV.id, color: familyV.option1 };
      }
    }

    // Skip card only if exact color exists OOS AND no family fallback is available. See #86.
    if (!matched && colorUpper && product.variants) {
      if (AP_COLOR_MATCH.colorExistsInVariants(product.variants, colorUpper)) return '';
    }

    // Step 3: first available variant (not product.price which is the minimum
    // across ALL variants and may not match the PDP landing price).
    if (!matched && product.variants) {
      var fallbackV = AP_COLOR_MATCH.findFallbackVariant(product.variants);
      if (fallbackV) {
        matched = { price: fallbackV.price / 100, id: fallbackV.id, color: fallbackV.option1 };
      }
    }

    // Image: re-match to the chosen variant's color (handles all three cases).
    // #279: pass variants for image_id link resolution.
    if (matched && matched.color && product.images) {
      var img = AP_COLOR_MATCH.findColorMatchedImage(product.images, matched.color, true, product.variants);
      if (img) imgSrc = img.src;
    }

    // Pricing: use matched variant
    var displayPrice = matched ? matched.price : product.price / 100;
    var price = formatMoney.format(displayPrice);

    // Link: append ?variant= when we matched a variant
    var baseUrl = (product.url || '').split('?')[0];
    var linkParam = matched ? '?variant=' + matched.id : '';

    imgSrc = imgSrc ? imgSrc.replace(/(\.[^.]+)$/, '_300x$1') : '';
    var isUnisex = (product.tags || []).some(function(t) { return t.toLowerCase() === 'unisex'; });
    var unisexBadge = isUnisex ? '<span class="s-product-card__unisex-badge" title="Unisex" style="position:absolute;top:0.6rem;left:0.6rem">&#x26A5;</span>' : '';
    return (
      '<a href="' + baseUrl + linkParam + '" class="s-cart-drawer__rec-card" style="position:relative">' +
        unisexBadge +
        '<img class="s-cart-drawer__rec-card__image" src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="140" height="175">' +
        '<p class="s-cart-drawer__rec-card__vendor">' + escapeHtml(product.vendor || '') + (function() { var c = getCollectionTagRaw(product.tags || []); return c ? ' <span class="s-cart-drawer__rec-card__collection">&middot; ' + escapeHtml(c) + '</span>' : ''; })() + '</p>' +
        '<p class="s-cart-drawer__rec-card__title">' + escapeHtml(product.title.replace(product.vendor || '', '').replace(/\bAPPAREL\b/gi, '').replace(/\s{2,}/g, ' ').trim()) + '</p>' +
        '<p class="s-cart-drawer__rec-card__price">' + price + '</p>' +
      '</a>'
    );
  }

  // --- Central add-to-cart handler ---

  function handleAddToCart(variantId, quantity, productData) {
    if (isAdding) return;
    isAdding = true;

    // Disable the triggering button if provided
    const btn = productData._triggerBtn;
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
    })
      .then((res) => {
        if (!res.ok) throw new Error('Could not add to cart');
        return fetch('/cart.js');
      })
      .then((res) => res.json())
      .then((cart) => {
        setDrawerItem(productData);
        setDrawerSubtotal(cart.item_count, cart.total_price);
        updateCartCount(cart.item_count);
        loadRecommendations(productData.productId, productData.color);
        openDrawer();
        var item = gaItemFromProductData(productData);
        if (item) {
          item.quantity = quantity || 1;
          gaTrack('add_to_cart', { currency: 'USD', value: item.price * item.quantity, items: [item] });
        }
      })
      .catch(() => {
        showError('This item could not be added to your bag. Please try again.');
        openDrawer();
      })
      .finally(() => {
        isAdding = false;
        if (btn) btn.disabled = false;
      });
  }

  // --- Intercept main product form ---

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (isAdding) return;

      const variantId = productForm.querySelector('[data-variant-id]')?.value;
      if (!variantId) return;

      const productId = productForm.dataset.productId || '';
      const title = document.querySelector('.s-pdp__title')?.textContent?.trim() || '';

      // Get active gallery image
      const activeImg = document.querySelector('.s-pdp__image.is-active') ||
                        document.querySelector('.s-pdp__image');
      const image = activeImg?.src || '';

      // Get selected color
      const selectedColor = document.querySelector('.s-pdp__color-swatch.is-selected');
      const color = selectedColor?.getAttribute('data-option-value') ||
                    selectedColor?.getAttribute('title') || '';

      // Get selected size (from the Size option group, not Subsize)
      const sizeGroup = document.querySelector('.s-pdp__option[data-option-name="subsize"]');
      const selectedSize = Array.from(document.querySelectorAll('.s-pdp__size-btn.is-selected'))
        .find(btn => !btn.closest('[data-option-name="subsize"]'));
      const size = selectedSize?.getAttribute('data-option-value') || '';

      // Get selected subsize
      const selectedSubsize = sizeGroup?.querySelector('.s-pdp__size-btn.is-selected');
      const subsize = selectedSubsize?.getAttribute('data-option-value') || '';

      // Get price
      const price = document.querySelector('[data-atc-price]')?.textContent?.trim() || '';

      const atcBtn = productForm.querySelector('[data-add-to-cart]');

      // Quantity from the PDP stepper (falls back to 1 if absent/invalid)
      let quantity = parseInt(productForm.querySelector('[data-pdp-qty-input]')?.value, 10);
      if (isNaN(quantity) || quantity < 1) quantity = 1;

      handleAddToCart(variantId, quantity, {
        productId,
        title,
        image,
        color,
        size,
        subsize,
        price,
        _triggerBtn: atcBtn
      });
    });
  }

  // Expose for external callers (e.g. Shop the Look)
  window.AP_CART_DRAWER = { handleAddToCart, open: openDrawer, close: closeDrawer };
}

/* ----------------------------------------------------------------------------
   Announcement Bar Rotation
   -------------------------------------------------------------------------- */

function initAnnouncementBar() {
  const bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  const messages = bar.querySelectorAll('[data-announcement-message]');
  if (messages.length <= 1) return;

  let current = 0;

  setInterval(() => {
    messages[current].classList.remove('is-active');
    current = (current + 1) % messages.length;
    messages[current].classList.add('is-active');
  }, 5000);
}

/* ----------------------------------------------------------------------------
   Reviews Carousel
   -------------------------------------------------------------------------- */

function initReviewsCarousel() {
  const track = document.querySelector('[data-reviews-track]');
  const prevBtn = document.querySelector('[data-reviews-prev]');
  const nextBtn = document.querySelector('[data-reviews-next]');
  if (!track || !prevBtn || !nextBtn) return;

  // Stride = card width + gap. Click advances by full viewport of cards
  // so the user sees a clear "page change", not a single-card nudge.
  function getStep() {
    const card = track.querySelector('.s-reviews__card');
    if (!card) return 340;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
    const stride = card.offsetWidth + gap;
    const visibleCards = Math.max(1, Math.floor(track.clientWidth / stride));
    return stride * visibleCards;
  }

  function updateButtons() {
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
    prevBtn.style.opacity = atStart ? '0.35' : '';
    nextBtn.style.opacity = atEnd ? '0.35' : '';
  }

  prevBtn.addEventListener('click', () => {
    track.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    track.scrollBy({ left: getStep(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateButtons, { passive: true });
  updateButtons();
}

/* ----------------------------------------------------------------------------
   #226 WYSIWYG: Shared card pricing update from swatch dot data attributes.
   Used by: swatch click, initCollectionColorMatch, DOM color filter.
   Reads data-swatch-price / data-swatch-compare / data-variant-id from a
   swatch dot and updates the card's price HTML, badge, link, and data-price.
   -------------------------------------------------------------------------- */

function updateCardPricingFromDot(card, dot) {
  var rawPrice = dot.dataset.swatchPrice;
  if (!rawPrice) return; // OOS color — no price data, skip gracefully

  var price = parseFloat(rawPrice) / 100;  // Shopify prices in cents
  var rawCompare = dot.dataset.swatchCompare;
  var compare = rawCompare ? parseFloat(rawCompare) / 100 : 0;
  var hasDiscount = compare > price && compare > 0;

  // Update price HTML
  var priceEl = card.querySelector('.s-product-card__price');
  if (priceEl) {
    if (hasDiscount) {
      priceEl.innerHTML = '<s class="s-product-card__compare-price">$' + compare.toFixed(2) + '</s>\n      $' + price.toFixed(2);
    } else {
      priceEl.textContent = '$' + price.toFixed(2);
    }
  }

  // Update badge (create if needed for newly-discounted color)
  var badgeEl = card.querySelector('.s-product-card__badge');
  if (hasDiscount) {
    // Floor to match Liquid `divided_by` in product-card.liquid:175.
    // Invariant: displayed % must never overstate the actual discount.
    var pct = Math.floor((compare - price) / compare * 100);
    if (badgeEl) {
      badgeEl.textContent = pct + '% OFF';
      badgeEl.style.display = '';
    } else {
      var imageWrap = card.querySelector('.s-product-card__image-wrap');
      if (imageWrap) {
        badgeEl = document.createElement('span');
        badgeEl.className = 's-product-card__badge';
        badgeEl.textContent = pct + '% OFF';
        imageWrap.insertBefore(badgeEl, imageWrap.firstChild);
      }
    }
  } else if (badgeEl) {
    badgeEl.textContent = '';
    badgeEl.style.display = 'none';
  }

  // Update link to ?variant= for WYSIWYG click-through
  var link = card.querySelector('[data-card-link]');
  var variantId = dot.dataset.variantId;
  if (link) {
    var baseUrl = link.getAttribute('href').split('?')[0];
    if (variantId) {
      link.setAttribute('href', baseUrl + '?variant=' + variantId);
    } else {
      // OOS fallback — use ?color= so PDP can show the right color
      link.setAttribute('href', baseUrl + '?color=' + encodeURIComponent(dot.dataset.cardColor || ''));
    }
  }

  // Update data-price for price filter consistency
  card.dataset.price = price.toFixed(2);
}

/* ----------------------------------------------------------------------------
   Product Card Color Swatches
   -------------------------------------------------------------------------- */

function initProductCardSwatches() {
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-card-color]');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();

    const card = dot.closest('[data-product-card]');
    if (!card) return;

    const img = card.querySelector('[data-card-image]');
    const more = card.querySelector('[data-card-more]');
    const imageUrl = dot.dataset.imageUrl;
    const variantId = dot.dataset.variantId;

    // Swap image if URL available
    if (imageUrl && img) {
      img.src = imageUrl;
      img.srcset = imageUrl.replace('width=600', 'width=300') + ' 300w, ' + imageUrl + ' 600w';
    }

    // #98: Update the +N badge href to navigate to PDP at the currently selected variant.
    if (more && variantId) {
      const baseUrl = more.getAttribute('href').split('?')[0];
      more.setAttribute('href', baseUrl + '?variant=' + variantId);
    }

    // Active state
    card.querySelectorAll('[data-card-color]').forEach((d) => d.classList.remove('is-active'));
    dot.classList.add('is-active');

    // #226 WYSIWYG: Update price, badge, and link from swatch data attributes.
    // Replaces the old fetch('/products/{handle}.js') approach — synchronous,
    // no flash of wrong price, works offline.
    updateCardPricingFromDot(card, dot);
  });

  // #98: Stop the card-link overlay from capturing +N badge clicks.
  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-card-more]');
    if (!more) return;
    e.stopPropagation();
  }, true);
}

/* ----------------------------------------------------------------------------
   Collection Color Auto-Select — swap card images to match collection color
   -------------------------------------------------------------------------- */

function initCollectionColorMatch() {
  if (typeof AP_COLOR_MAP === 'undefined') return;

  var match = window.location.pathname.match(/\/collections\/([^/?]+)/);
  if (!match) return;
  var handle = match[1].toLowerCase();

  var COLOR_HANDLES = {
    'black-scrubs':          ['black'],
    'navy-scrubs':           ['navy', 'indigo', 'cobalt', 'imperial'],
    'wine-scrubs':           ['wine', 'raspberry coulis', 'tea berry'],
    'teal-scrubs':           ['teal', 'surgical green', 'real teal'],
    'royal-blue-scrubs':     ['royal', 'galaxy'],
    'lavender-scrubs':       ['lavender', 'orchid bouquet', 'orchid bloom', 'light mauve'],
    'pink-scrubs':           ['pink', 'rose', 'fuchsia', 'raspberry', 'watermelon', 'mauve', 'blossom', 'bella rosa', 'bright rose', 'candy pink', 'blush pink', 'passion pink', 'alloy pink', 'dancing blossom', 'wild rose', 'slate rose', 'hollyhock'],
    'gray-scrubs':           ['gray', 'grey', 'graphite', 'pewter', 'steel', 'charcoal', 'slate', 'quiet grey', 'taylor grey', 'metallic silver'],
    'green-scrubs':          ['green', 'mint', 'honeydew', 'patina green', 'mint julep', 'cool mint', 'apple green', 'lime', 'acid lime', 'apple'],
    'white-scrubs':          ['white', 'light gray'],
    'ceil-blue-scrubs':      ['ceil', 'ciel'],
    'caribbean-blue-scrubs': ['caribbean'],
    'hunter-green-scrubs':   ['hunter', 'mountain view', 'lush green', 'true hunter'],
    'eggplant-scrubs':       ['eggplant', 'purple', 'grape', 'dahlia', 'ultra violet', 'deep purple', 'mulberry', 'true purple', 'electric purple'],
    'khaki-scrubs':          ['khaki', 'sandstone', 'taupe', 'brown', 'chocolate', 'tender rose'],
    'red-scrubs':            ['red', 'crimson', 'cherry', 'cherries jubilee', 'racing red', 'true red'],
    'olive-scrubs':          ['olive', 'olive moss', 'moss'],
    'yellow-scrubs':         ['yellow', 'sunshine', 'lemon', 'lime', 'acid', 'citron', 'illuminate', 'primrose'],
    'coral-scrubs':          ['coral', 'fresh salmon', 'deep coral', 'coral sunset', 'coral pop', 'living coral', 'desert coral', 'desert flower', 'peony pink', 'orange'],
    'sage-scrubs':           ['sage', 'seagrass', 'sea mist'],
    'sky-blue-scrubs':       ['sky blue', 'ethereal blue', 'opal'],
    'aruba-blue-scrubs':     ['aruba', 'island blue', 'scuba blue'],
    'postman-blue-scrubs':   ['postman blue', 'infinity blue', 'slate blue', 'mykonos', 'atlantic blue', 'ocean wave', 'peacock blue'],
    'aqua-blue-scrubs':      ['aqua', 'maui blue', 'malibu blue', 'pacific blue', 'cyan blue', 'aquamarine', 'lake blue', 'turquoise']
  };

  var matchTerms = COLOR_HANDLES[handle];
  if (!matchTerms) return;

  var cards = document.querySelectorAll('[data-product-card]');
  cards.forEach(function(card) {
    var dots = card.querySelectorAll('[data-card-color]');
    if (!dots.length) return;

    var matched = null;
    for (var i = 0; i < dots.length; i++) {
      var colorName = AP_COLOR_MAP.normalize(dots[i].dataset.cardColor);
      for (var j = 0; j < matchTerms.length; j++) {
        if (colorName.indexOf(matchTerms[j]) !== -1) {
          matched = dots[i];
          break;
        }
      }
      if (matched) break;
    }

    if (!matched) {
      card.style.display = 'none';
      return;
    }

    var img = card.querySelector('[data-card-image]');
    var imageUrl = matched.dataset.imageUrl;

    // Hide card if matched color has no image — can't show the right color
    if (!imageUrl) {
      card.style.display = 'none';
      return;
    }

    if (img) {
      img.src = imageUrl;
      img.srcset = imageUrl.replace('width=600', 'width=300') + ' 300w, ' + imageUrl + ' 600w';
    }

    dots.forEach(function(d) { d.classList.remove('is-active'); });
    matched.classList.add('is-active');

    // #226 WYSIWYG: Update price, badge, and link to match the swapped color.
    // Before this fix, only image and swatch were swapped — price/badge stayed
    // from the original discounted variant, creating a bait-and-switch.
    updateCardPricingFromDot(card, matched);
  });

  // Update visible product count after hiding mismatched cards
  var countEl = document.querySelector('.s-collection__count');
  if (countEl) {
    var visibleCards = document.querySelectorAll('[data-product-card]:not([style*="display: none"])');
    countEl.textContent = visibleCards.length + ' products';
  }
}

/* ----------------------------------------------------------------------------
   Size Chart Modal
   -------------------------------------------------------------------------- */

function initSizeChartModal() {
  const openBtn = document.querySelector('[data-size-chart-open]');
  const modal = document.querySelector('[data-size-chart-modal]');
  const overlay = document.querySelector('[data-size-chart-overlay]');
  const closeBtn = document.querySelector('[data-size-chart-close]');
  if (!openBtn || !modal) return;

  function open() {
    modal.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
}

/* ----------------------------------------------------------------------------
   Shop the Look — Multi-product recommendations on PDP
   -------------------------------------------------------------------------- */

function initShopTheLook() {
  const productForm = document.querySelector('[data-product-form]');
  if (!productForm) return;
  const productId = productForm.dataset.productId;
  if (!productId) return;

  // Find existing slider from Liquid, or create one if none exists
  const slider = document.querySelector('[data-look-slider]');
  const matchSection = document.querySelector('[data-match-section]');
  const pdpSection = document.querySelector('.s-pdp');

  // Wire arrow scroll buttons for any slider (Liquid-rendered or JS-created)
  function wireArrows(sliderEl) {
    const arrows = sliderEl.closest('.s-pdp__complete-set');
    if (!arrows) return;
    const prev = arrows.querySelector('[data-look-prev]');
    const next = arrows.querySelector('[data-look-next]');
    if (!prev || !next) return;
    const amt = 220;
    prev.addEventListener('click', () => { sliderEl.scrollBy({ left: -amt, behavior: 'smooth' }); });
    next.addEventListener('click', () => { sliderEl.scrollBy({ left: amt, behavior: 'smooth' }); });
  }

  // Wire up Liquid-rendered arrows immediately
  if (slider) wireArrows(slider);

  // #112: When Liquid marks the slider as source-of-truth, skip the
  // /recommendations/products.json fallback. The Liquid waterfall already
  // chose the right products (gender, complementary type, color/brand/collection
  // tiers) — appending Shopify's native recommendations would pollute the
  // carousel with same-type or opposite-gender products.
  if (slider && slider.hasAttribute('data-liquid-source-of-truth')) {
    return;
  }

  const currentGender = getProductGender();

  function filterProducts(products) {
    return products.filter(p => {
      const rGender = getGenderFromTags(p.tags || []);
      return isGenderCompatible(currentGender, rGender);
    });
  }

  // Get the currently selected color on the PDP
  const selectedColorEl = document.querySelector('.s-pdp__color-swatch.is-selected');
  const selectedColor = selectedColorEl ? (selectedColorEl.getAttribute('data-option-value') || '').toUpperCase() : '';

  function getProductColorValues(product) {
    var colors = [];
    (product.options || []).forEach(function(o) {
      if (apOptionRole(o.name) === 'color') {
        colors = (o.values || []).map(function(v) { return v.toUpperCase(); });
      }
    });
    return colors;
  }

  function hasMatchingColor(product, color) {
    if (!color) return false;
    var stripped = color.split(' (')[0];
    return getProductColorValues(product).some(function(v) {
      var vs = v.split(' (')[0];
      return v.includes(color) || color.includes(vs) || vs.includes(stripped) || stripped.includes(vs);
    });
  }

  function renderCard(product) {
    var imgSrc = product.featured_image
      ? product.featured_image.replace(/(\.[^.]+)$/, '_300x$1')
      : '';
    const colorValues = getProductColorValues(product).join(',');
    const formatMoney = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const title = product.title.replace(product.vendor || '', '').replace(/\bAPPAREL\b/gi, '').replace(/\s{2,}/g, ' ').trim();

    // 3-step variant selection (#283): exact → same-family → first-available.
    // Image is re-matched to the chosen variant's color so href, price, and
    // image always agree. See #76, #227, #282.
    var matched = null;
    var selUpper = selectedColor ? selectedColor.toUpperCase() : '';

    // Step 1: exact color match
    if (selUpper && product.variants) {
      var matchedV = AP_COLOR_MATCH.findColorMatchedVariant(product.variants, selUpper);
      if (matchedV) {
        matched = { price: matchedV.price / 100, id: matchedV.id, color: matchedV.option1 };
      }
    }

    // Step 2: same-family match (#283)
    if (!matched && selUpper && product.variants) {
      var familyV = AP_COLOR_MATCH.findFamilyMatchedVariant(product.variants, selUpper);
      if (familyV) {
        matched = { price: familyV.price / 100, id: familyV.id, color: familyV.option1 };
      }
    }

    // Skip card only if exact color exists OOS AND no family fallback. See #86, #227.
    if (!matched && selUpper && product.variants) {
      if (AP_COLOR_MATCH.colorExistsInVariants(product.variants, selUpper)) return '';
    }

    // Step 3: first available variant
    if (!matched && product.variants) {
      var fallbackV = AP_COLOR_MATCH.findFallbackVariant(product.variants);
      if (fallbackV) {
        matched = { price: fallbackV.price / 100, id: fallbackV.id, color: fallbackV.option1 };
      }
    }

    // Image: re-match to the chosen variant's color (handles all three steps).
    if (matched && matched.color && product.images && product.images.length) {
      var img = AP_COLOR_MATCH.findColorMatchedImage(product.images, matched.color, true, product.variants);
      if (img) imgSrc = img.src.replace(/(\.[^.]+)$/, '_300x$1');
    }

    // Pricing: use matched variant
    var displayPrice = matched ? matched.price : product.price / 100;
    var price = formatMoney.format(displayPrice);
    var badgeHtml = '<span class="s-product-card__badge" data-look-badge style="display:none"></span>';

    // Link: only append ?variant= when we matched a color variant.
    // Do NOT append ?color= for unmatched products — it causes price/color
    // mismatch on landing. Strip tracking params from Recommendations API URLs. See #76.
    var baseUrl = (product.url || '').split('?')[0];
    var linkParam = '';
    if (matched) {
      linkParam = '?variant=' + matched.id;
    }

    // Collection tag
    var _colRaw = getCollectionTagRaw(product.tags || []);
    var collectionHtml = _colRaw ? ' <span class="s-pdp__look-card__collection">&middot; ' + escapeHtml(_colRaw) + '</span>' : '';

    return (
      '<a href="' + baseUrl + linkParam + '" class="s-pdp__look-card" style="position:relative" data-look-product-id="' + product.id + '" data-product-colors="' + escapeHtml(colorValues) + '">' +
        '<div class="s-pdp__look-card__image-wrap">' +
          badgeHtml +
          (imgSrc ? '<img class="s-pdp__look-card__image" src="' + imgSrc + '" alt="" loading="lazy" width="200" height="250">' : '') +
        '</div>' +
        '<p class="s-pdp__look-card__vendor">' + escapeHtml(product.vendor || '') + collectionHtml + '</p>' +
        '<p class="s-pdp__look-card__title">' + escapeHtml(title) + '</p>' +
        '<p class="s-pdp__look-card__price" data-look-price>' + price + '</p>' +
      '</a>'
    );
  }

  // Collect IDs already in the Liquid slider to avoid duplicates
  const existingIds = new Set();
  if (slider) {
    slider.querySelectorAll('[data-look-product-id]').forEach(el => {
      existingIds.add(String(el.dataset.lookProductId));
    });
  }
  existingIds.add(productId);

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary')
    .then(r => r.json())
    .then(data => {
      let products = filterProducts(data.products || []);
      products = products.filter(p => !existingIds.has(String(p.id)));

      if (products.length < 3) {
        return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
          .then(r => r.json())
          .then(d2 => {
            const related = filterProducts(d2.products || []);
            const seen = new Set(products.map(p => String(p.id)));
            existingIds.forEach(id => seen.add(id));
            related.forEach(p => { if (!seen.has(String(p.id))) { products.push(p); seen.add(String(p.id)); }});
            return products;
          });
      }
      return products;
    })
    .then(products => {
      if (!products || products.length === 0) return;

      // Sort: products with the selected color first
      if (selectedColor) {
        products.sort((a, b) => {
          return (hasMatchingColor(b, selectedColor) ? 1 : 0) - (hasMatchingColor(a, selectedColor) ? 1 : 0);
        });
      }

      const displayProducts = products.slice(0, 8);
      const cardsHtml = displayProducts.map(renderCard).join('');

      if (slider) {
        // Append into existing Liquid slider
        slider.insertAdjacentHTML('beforeend', cardsHtml);
      } else {
        // No Liquid slider — create a new section
        const anchor = matchSection || pdpSection;
        if (!anchor) return;

        const wrapper = document.createElement('section');
        wrapper.className = 's-pdp__complete-set';
        wrapper.setAttribute('data-match-section', '');
        wrapper.innerHTML =
          '<div class="container">' +
            '<div class="s-pdp__look-header">' +
              '<h2 class="s-pdp__complete-set-title">Shop the Look</h2>' +
              '<div class="s-pdp__look-arrows">' +
                '<button type="button" class="s-pdp__look-arrow" data-look-prev aria-label="Scroll left">&#8249;</button>' +
                '<button type="button" class="s-pdp__look-arrow" data-look-next aria-label="Scroll right">&#8250;</button>' +
              '</div>' +
            '</div>' +
            '<div class="s-pdp__look-slider" data-look-slider>' +
              cardsHtml +
            '</div>' +
          '</div>';
        anchor.after(wrapper);

        // Wire up arrow scroll for dynamically created slider
        const newSlider = wrapper.querySelector('[data-look-slider]');
        if (newSlider) wireArrows(newSlider);
      }

      // Ensure arrows exist on every Shop the Look section
      document.querySelectorAll('.s-pdp__complete-set').forEach(section => {
        const sl = section.querySelector('[data-look-slider]');
        if (!sl) return;
        let header = section.querySelector('.s-pdp__look-header');
        if (!header) {
          header = document.createElement('div');
          header.className = 's-pdp__look-header';
          header.innerHTML =
            '<h2 class="s-pdp__complete-set-title">Shop the Look</h2>' +
            '<div class="s-pdp__look-arrows">' +
              '<button type="button" class="s-pdp__look-arrow" data-look-prev aria-label="Scroll left">&#8249;</button>' +
              '<button type="button" class="s-pdp__look-arrow" data-look-next aria-label="Scroll right">&#8250;</button>' +
            '</div>';
          sl.parentElement.insertBefore(header, sl);
          wireArrows(sl);
        } else if (!section.querySelector('[data-look-prev]')) {
          const arrows = document.createElement('div');
          arrows.className = 's-pdp__look-arrows';
          arrows.innerHTML =
            '<button type="button" class="s-pdp__look-arrow" data-look-prev aria-label="Scroll left">&#8249;</button>' +
            '<button type="button" class="s-pdp__look-arrow" data-look-next aria-label="Scroll right">&#8250;</button>';
          header.appendChild(arrows);
          wireArrows(sl);
        }
      });

      if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) {
        AP_COLOR_MAP.applyAll();
      }

      // Color-match JS-rendered card images. The Recommendations API returns
      // images as bare URLs (no alt text), so fetch /products/{handle}.json
      // for each card to get alt text for color matching. Fixes #87, #227.
      if (selectedColor) {
        displayProducts.forEach(function(product) {
          if (!product.handle) return;
          var cardEl = document.querySelector('.s-pdp__look-card[data-look-product-id="' + product.id + '"]');
          if (!cardEl) return;
          var imgEl = cardEl.querySelector('.s-pdp__look-card__image');
          if (!imgEl) return;
          fetch('/products/' + product.handle + '.json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var images = (data.product && data.product.images) || [];
              var variants = (data.product && data.product.variants) || [];
              var matched = AP_COLOR_MATCH.findColorMatchedImage(images, selectedColor, true, variants);
              if (matched) {
                imgEl.src = matched.src.replace(/\?.*/, '?width=400');
              }
            })
            .catch(function() {});
        });
      }
    })
    .catch(() => { console.warn('Shop the Look load failed'); });

}

/* ----------------------------------------------------------------------------
   Collection Filters — Full client-side filter bar
   -------------------------------------------------------------------------- */

function initCollectionFilters() {
  var filterBar = document.querySelector('[data-filter-bar]');
  if (!filterBar) return;

  // W3 (#330 S6): '1XL' is a vendor label for XL — map it so those variants match.
  var SIZE_ALIASES = { 'SML': 'S', 'SM': 'S', 'XSM': 'XS', 'MED': 'M', 'MD': 'M', 'LGE': 'L', 'XLG': 'XL', 'XXL': '2XL', '1XL': 'XL', '6T': '6', '8T': '8', '10T': '10', '12T': '12', '14T': '14', '16T': '16' };

  // Fix #140: letter→numeric size mapping so numeric-sized lab coats appear
  // when a customer clicks a letter size (XXS-5XL). Replaces the old #127 BUG #B
  // "Pant Waist" / "Numeric" / "One Size" grouped buckets with transparent mapping.
  var LETTER_TO_NUMERIC = {
    'XXS': /^0$/,
    'XS':  /^(2|32|34)$/,
    'S':   /^(4|6|34|36|38)L?$/,
    'M':   /^(8|10|38|40|42)L?$/,
    'L':   /^(12|14|42|44|46)L?$/,
    'XL':  /^(16|18|46|48|50)L?$/,
    '2XL': /^(20|50|52|54)L?$/,
    '3XL': /^(54|56)L?$/
  };

  // Given a card's size list and a selected filter value, does it match?
  // Checks literal letter match first, then falls back to letter→numeric mapping.
  function cardSizesMatchFilter(normalizedCardSizes, filterValue) {
    var fv = filterValue.toUpperCase();
    // Literal letter-size match
    if (normalizedCardSizes.indexOf(fv) !== -1) return true;
    // Letter→numeric mapping: does the product have a numeric size in this letter's range?
    var numericRe = LETTER_TO_NUMERIC[fv];
    if (numericRe) {
      return normalizedCardSizes.some(function(s) { return numericRe.test(s); });
    }
    return false;
  }

  // Move Filter button into header row on mobile collection pages only
  var headerToggle = document.querySelector('.s-header__mobile-toggle');
  var filterBtn = document.querySelector('[data-mobile-filter-open]');
  if (headerToggle && filterBtn && window.innerWidth < 1024) {
    headerToggle.parentNode.insertBefore(filterBtn, headerToggle.nextSibling);
  }

  var cards = document.querySelectorAll('[data-product-card]');
  var grid = document.querySelector('[data-product-grid]');
  var countEl = document.querySelector('[data-product-count]');
  var originalCountText = countEl ? countEl.textContent : '';
  var tagsContainer = document.querySelector('[data-filter-tags]');
  var noResults = document.querySelector('[data-no-results]');
  var backdrop = document.querySelector('[data-filter-backdrop]');
  var clearAllBtn = document.querySelector('[data-clear-all-filters]');
  var openDropdownEl = null;
  var fetchDebounceTimer = null;
  var cachedProducts = null;
  var cachedCollHandle = '';
  var cachedSortBy = '';
  var fetchGeneration = 0; // Incremented on clear to abort stale AJAX responses
  var ajaxFilteredProducts = []; // #195: full filtered list for AJAX pagination
  var ajaxRenderedCount = 0;      // #195: how many AJAX cards currently shown
  var AJAX_PAGE_SIZE = 48;        // #195: match server-side pagination

  // Save original card state for reset when color filter is cleared.
  // #226: Also save price, badge, and link — not just image.
  cards.forEach(function(card) {
    var img = card.querySelector('[data-card-image]');
    if (img) card.dataset.originalSrc = img.src;
    var priceEl = card.querySelector('.s-product-card__price');
    if (priceEl) card.dataset.originalPriceHtml = priceEl.innerHTML;
    var badgeEl = card.querySelector('.s-product-card__badge');
    if (badgeEl) {
      card.dataset.originalBadgeHtml = badgeEl.innerHTML;
      card.dataset.originalBadgeDisplay = badgeEl.style.display || '';
    }
    var link = card.querySelector('[data-card-link]');
    if (link) card.dataset.originalHref = link.getAttribute('href');
    card.dataset.originalDataPrice = card.dataset.price || '';
  });

  // Fabric mapping from collection line
  var FABRIC_MAP = {
    'proflex': '2-Way Stretch', 'forward': '4-Way Stretch', 'eon': 'Rayon Blend',
    'momentum': '4-Way Stretch', 'blossom': 'Polyester Blend', 'red panda': 'Polyester Blend',
    'matrix': '4-Way Stretch', 'focus': '4-Way Stretch', 'essentials': 'Polycotton',
    'scrub zone': 'Polycotton', 'crft': '4-Way Stretch', 'vibe': 'Rayon Blend',
    'v-tess': 'Rayon Blend', 'core': 'Polycotton', 'knit': 'Polyester Blend',
    'bestee': 'Rayon Blend', 'blossom signature': 'Polyester Blend',
    'core program': 'Polycotton', 'eon sport': 'Rayon Blend',
    'essential lab coats': 'Polycotton', 'fit': 'Rayon Blend',
    'matrix basic': '4-Way Stretch', 'matrix impulse': '4-Way Stretch',
    'matrix mens': '4-Way Stretch', 'matrix pro': '4-Way Stretch',
    'matrix pro mens': '4-Way Stretch', 'matrix underscrub': '4-Way Stretch',
    'mens': 'Polycotton', 'prints': 'Polyester Blend',
    'redpanda': 'Polyester Blend', 'scrub cap': 'Polyester Blend',
    // W4 (#330 S5/D2, Matt-approved 2026-07-04): 26 CBI-era + WC lines that
    // arrived after this map was written — 200 products were invisible to the
    // Fabric filter. Forward rule: imports populate custom.fabric metafield.
    'ww revolution': '4-Way Stretch', 'ww originals ultra': 'Polycotton',
    'ww originals': 'Polycotton', 'in infinity': '4-Way Stretch',
    'in pursuit': '4-Way Stretch', 'achieve': '4-Way Stretch',
    'allura': '4-Way Stretch', 'quest': '4-Way Stretch',
    'works': '4-Way Stretch', '360': '4-Way Stretch',
    'purple label': 'Rayon Blend', 'purple label jacquard': 'Rayon Blend',
    'eds essentials': '4-Way Stretch', 'eds signature': 'Polycotton',
    'balance': '4-Way Stretch', 'dynamix': '4-Way Stretch',
    'forge': '4-Way Stretch', 'amp': '4-Way Stretch',
    'amp knit': 'Polyester Blend', 'insight': '4-Way Stretch',
    'touch': '4-Way Stretch', 'marvella': 'Polyester Blend',
    'allure': 'Polyester Blend', 'duo': 'Polyester Blend',
    'print': 'Polyester Blend', 'landau proflex': '2-Way Stretch'
  };

  // #151: COLOR_FAMILIES auto-built from AP_COLOR_MAP.masterGroups.
  // Single source of truth — edit color-map.js, everything updates.
  // Reference: 06 Reference/color-groups-master.md
  var COLOR_FAMILIES = {};
  if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.masterGroups) {
    for (var _g = 0; _g < AP_COLOR_MAP.masterGroups.length; _g++) {
      var _grp = AP_COLOR_MAP.masterGroups[_g];
      COLOR_FAMILIES[_grp.name] = _grp.aliases;
    }
  }

  // Fix #121: explicit overrides for compound print names where substring
  // collisions or tied longest-match results would misclassify the color.
  // Keys must be lowercased. Extend when new ambiguous print names surface.
  var COLOR_FAMILY_OVERRIDES = {
    'sunshine blossoms':     'Yellow', // 'blossom' (Pink) used to beat 'sunshine' (Yellow)
    'cherry berry lemonade': 'Yellow', // 'cherry' (Red) used to match before 'lemon' (Yellow)
    'pink grapefruit':       'Pink'    // 'grape' (5, Purple) ties 'pink' (4) under longest-match
  };

  // Fix #127 BUG #D: terms must match at a word boundary (start of string or
  // preceded by a non-letter). Without this, "Blush Pink" matches `lush` inside
  // "b[lush] pink" and gets filed as Green. With word-boundary checking, the
  // `lush` term only matches when it's a standalone word (e.g., "Lush Green"),
  // so Blush Pink falls through to `pink` and gets filed as Pink.
  function matchAtWordBoundary(lower, term) {
    var searchFrom = 0;
    while (true) {
      var pos = lower.indexOf(term, searchFrom);
      if (pos === -1) return false;
      // Word boundary = start of string OR previous char is not a letter
      if (pos === 0 || !/[a-z]/.test(lower.charAt(pos - 1))) return true;
      searchFrom = pos + 1;
    }
  }

  // Fix #121 / #127 BUG #D: was order-dependent first-match-wins with naive
  // substring matching (Pink/Red families declared before Yellow would win for
  // "Sunshine Blossoms", and "Blush Pink" matched `lush` in Green via substring).
  // Strategy:
  //   1. Explicit overrides for known compound print names (COLOR_FAMILY_OVERRIDES)
  //   2. Otherwise: longest-matching-term at a word boundary wins across all families
  //      (so "slate blue" (10) beats "slate" (5) for "Slate Blue" → Island Blue)
  function getColorFamily(colorName) {
    if (!colorName) return '';
    var lower = colorName.toLowerCase().replace(/\s*\([^)]*\)\s*$/, '').trim();
    if (COLOR_FAMILY_OVERRIDES[lower]) return COLOR_FAMILY_OVERRIDES[lower];
    var bestFamily = '';
    var bestLen = 0;
    for (var family in COLOR_FAMILIES) {
      var terms = COLOR_FAMILIES[family];
      for (var i = 0; i < terms.length; i++) {
        var t = terms[i];
        if (t.length > bestLen && matchAtWordBoundary(lower, t)) {
          bestFamily = family;
          bestLen = t.length;
        }
      }
    }
    if (bestFamily) return bestFamily;
    // #297: consult the print pattern → family table from color-map.js so
    // solid-color-but-not-in-master-aliases names (Mauve Shadows, Slate,
    // Scarlett, etc.) resolve to their true family (Pink, Pewter, Pink)
    // instead of falling through to a misleading 'Print' classification.
    if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.printGroups && AP_COLOR_MAP.printGroups[lower]) {
      return AP_COLOR_MAP.printGroups[lower];
    }
    // No family match — return '' so the product isn't bucketed into Print
    // by mistake. The 'Print' filter is now driven exclusively by the
    // Prints collection-line injection in normalizeProduct().
    return '';
  }

  function getFabric(collectionLine) {
    if (!collectionLine) return '';
    var key = collectionLine.toLowerCase();
    return FABRIC_MAP[key] || '';
  }

  // --- Cascading filter helpers (#166) ---

  // Extracted from filterAndRenderProducts() inline logic (was lines 1934-1945)
  function getProductTypeFromTags(tags) {
    // Specific types first — many products carry both 'top' and a more-specific
    // type tag like 'underscrub' (an underscrub IS a top). Generic 'top' last
    // mirrors the DOM-path recognizer (product-card.liquid) where last-iteration
    // wins on alphabetical tag order. Without this, AJAX-filter results lose
    // products that should match Underscrub/Cap/Skirt/Dress/Lab Coat.
    if (tags.indexOf('lab coat') !== -1) return 'Lab Coat';
    if (tags.indexOf('cap') !== -1) return 'Cap';
    if (tags.indexOf('underscrub') !== -1 || tags.indexOf('under scrub') !== -1 || tags.indexOf('underscrubs') !== -1 || tags.indexOf('under scrubs') !== -1) return 'Underscrub';
    if (tags.indexOf('skirt') !== -1) return 'Skirt';
    if (tags.indexOf('dress') !== -1 || tags.indexOf('bodysuit') !== -1 || tags.indexOf('jumpsuit') !== -1) return 'Dress';
    if (tags.indexOf('jacket') !== -1 || tags.indexOf('warm-up') !== -1) return 'Jacket';
    if (tags.indexOf('pant') !== -1 || tags.indexOf('pants') !== -1 || tags.indexOf('jogger') !== -1) return 'Pant';
    if (tags.indexOf('top') !== -1 || tags.indexOf('tunic') !== -1 || tags.indexOf('shirt') !== -1) return 'Top';
    return '';
  }

  // #374: 'Prints' is a PATTERN facet surfaced in the Product type menu.
  // Unlike Top/Pant/etc it is NOT derivable from a product's own type tags —
  // a printed top is still type=Top. It comes from the COLLECTION:Prints line
  // tag, the same signal that drives the Print colour swatch.
  // W4 (#330 S7): Sanibel's line tag is 'Print' (singular) — accept both.
  var PRINT_TYPE_VALUE = 'Prints';
  function isPrintLine(line) {
    var l = (line || '').toLowerCase();
    return l === 'prints' || l === 'print';
  }

  // Shared type-facet matcher. Used by the DOM path, the AJAX path AND the
  // cascading-availability computation so all three agree — a product hidden
  // by one path but counted as available by another is the classic filter bug.
  function typeMatches(selected, ownType, collectionLine) {
    if (selected.indexOf(ownType) !== -1) return true;
    if (selected.indexOf(PRINT_TYPE_VALUE) !== -1 && isPrintLine(collectionLine)) return true;
    return false;
  }

  function mapLengthToFilterLabel(val) {
    var v = (val || '').toLowerCase();
    if (v === 'petite' || v === 'short' || v === 'court' || v === 'petit') return 'Petite / Short';
    if (v === 'regular' || v === 'régulier' || v === 'regulier') return 'Regular';
    if (v === 'tall' || v === 'grand') return 'Tall';
    return val;
  }

  // #296 T6: shared facet→display-label map. Used by chip rendering AND
  // mobile drawer pill rendering (single source of truth). Raw checkbox
  // values stay URL-safe; display labels are customer-friendly.
  var FACET_VALUE_LABELS = {
    price: { '0-10': 'Under $10', '10-20': '$10 – $20', '20-30': '$20 – $30', '30-999': '$30+' }
    // Add brand/type/etc. overrides here as needed
  };
  function chipLabel(facet, value) {
    return (FACET_VALUE_LABELS[facet] && FACET_VALUE_LABELS[facet][value]) || value;
  }

  // ─── #296 Filter v2: dynamic augmentation from card scan ─────────────────
  // Pattern adopted from mobile drawer (buildDrawerBody). Reads card data-*
  // attributes, injects new <input> checkboxes for any value the Liquid
  // baseline didn't pre-emit. Lets the filter auto-adapt to new brands /
  // types / fabrics without theme code changes.

  // Feature flag — kill-switch path: shop.metafields.custom.ff_filter_v2,
  // or ?ff_filter_v2=1/0 query override (for QA before flipping shop-wide).
  function isFilterV2Enabled() {
    var qs = location.search;
    if (qs.indexOf('ff_filter_v2=1') !== -1) return true;
    if (qs.indexOf('ff_filter_v2=0') !== -1) return false;
    if (typeof window.AP_FF === 'object' && window.AP_FF && window.AP_FF.filter_v2 === true) return true;
    return false;
  }

  // Case-insensitive dedup. First-seen casing wins for display.
  function dedupByCase(values) {
    var seen = {};
    Object.keys(values).forEach(function(v) {
      var k = v.toLowerCase();
      if (!seen[k]) seen[k] = v;
    });
    var result = {};
    Object.keys(seen).forEach(function(k) { result[seen[k]] = true; });
    return result;
  }

  function scanCardsForFacetValues(cardList) {
    var map = { brand: {}, type: {}, fabric: {}, length: {} };
    cardList.forEach(function(card) {
      if (card.dataset.brand) map.brand[card.dataset.brand.trim()] = true;
      if (card.dataset.productType) map.type[card.dataset.productType.trim()] = true;
      var fab = getFabric(card.dataset.collectionLine || '');
      if (fab) map.fabric[fab] = true;
      // Length: keep RAW values (Petite / Short / Regular / Tall) to match the
      // Liquid baseline. mapLengthToFilterLabel collapses Petite+Short into a
      // combo label that the dropdown handles specially via the combo button —
      // injecting "Petite / Short" as its own option would create a phantom row.
      (card.dataset.lengths || '').split(',').filter(Boolean).forEach(function(l) {
        var raw = l.trim();
        if (raw) map.length[raw] = true;
      });
      // CBI subsize-split: read custom.subsize_self exposed on the card (raw)
      if (card.dataset.subsizeSelf) {
        var raws = card.dataset.subsizeSelf.trim();
        if (raws) map.length[raws] = true;
      }
    });
    Object.keys(map).forEach(function(facet) { map[facet] = dedupByCase(map[facet]); });
    return map;
  }

  // XSS-safe — createElement + .value setter + textContent, never innerHTML.
  // Wires the change listener inline so augmented checkboxes participate in
  // applyFilters() like Liquid baseline ones do (the init-time listener loop
  // at ~line 3314 only attaches to baseline checkboxes that existed at load).
  function augmentDropdown(facet, valueMap) {
    var panelBody = document.querySelector('[data-filter-panel="' + facet + '"] .s-filter__panel-body');
    if (!panelBody) return;
    var existing = {};
    panelBody.querySelectorAll('input[name="filter_' + facet + '"]').forEach(function(cb) {
      existing[cb.value.toLowerCase()] = true; // case-insensitive existence check
    });
    Object.keys(valueMap).sort().forEach(function(value) {
      if (!value || existing[value.toLowerCase()]) return;
      var label = document.createElement('label');
      label.className = 's-filter__option';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'filter_' + facet;
      input.value = value;
      input.addEventListener('change', function() {
        if (typeof syncPetiteShort === 'function') syncPetiteShort();
        if (typeof applyFilters === 'function') applyFilters();
      });
      var check = document.createElement('span');
      check.className = 's-filter__check';
      label.appendChild(input);
      label.appendChild(document.createTextNode(' '));
      label.appendChild(check);
      label.appendChild(document.createTextNode(' ' + value));
      panelBody.appendChild(label);
    });
  }

  function runAugmentation(cardList) {
    var map = scanCardsForFacetValues(cardList || cards);
    // Size: closed enum (XXS–5XL) — intentionally not augmented
    // Color: dynamic via color-map.js renderFilters() — already idempotent
    ['brand', 'type', 'fabric', 'length'].forEach(function(f) { augmentDropdown(f, map[f]); });
    return map;
  }

  // Track card count so AJAX re-augment (T1.5) only re-runs when needed.
  var _lastCardCount = 0;

  // Telemetry: report values JS injected (i.e., not in Liquid baseline).
  // Surfaces typos, casing drift, and new vendor strings from imports.
  function reportFilterDrift(facetMap) {
    if (!facetMap) return;
    var newValues = [];
    ['brand', 'type', 'fabric', 'length'].forEach(function(facet) {
      Object.keys(facetMap[facet]).forEach(function(v) {
        // CSS.escape guards the selector — values may contain CSS-significant chars
        var sel = 'input[name="filter_' + facet + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"][data-liquid-emitted]';
        var baseline = null;
        try { baseline = document.querySelector(sel); } catch (e) { /* selector parse error — treat as missing */ }
        if (!baseline) newValues.push(facet + '=' + v);
      });
    });
    if (newValues.length === 0) return;
    console.warn('[filter] Card values not in Liquid baseline:', newValues);
    // sessionStorage marker for QA inspection via DevTools
    try {
      var key = 'ap_filter_drift';
      var prev = JSON.parse(sessionStorage.getItem(key) || '[]');
      var merged = Array.from(new Set(prev.concat(newValues)));
      sessionStorage.setItem(key, JSON.stringify(merged));
    } catch (e) { /* sessionStorage unavailable */ }
    // Beacon to landing-hub Vercel endpoint, throttled once per fingerprint per session
    try {
      var sentKey = 'ap_filter_drift_sent';
      var fingerprint = newValues.sort().join('|');
      if (sessionStorage.getItem(sentKey) !== fingerprint) {
        sessionStorage.setItem(sentKey, fingerprint);
        navigator.sendBeacon(
          'https://ap-uniforms.com/api/filter-drift',
          JSON.stringify({
            store: ((window.AP_STORE && AP_STORE.code) || 'CA').toLowerCase(),
            theme: document.documentElement.dataset.themeId || '',
            url: location.pathname,
            drift: newValues,
            ua: navigator.userAgent,
            ts: Date.now()
          })
        );
      }
    } catch (e) { /* beacon unavailable — sessionStorage + console still captured */ }
  }

  // Run augmentation once at init, gated on feature flag.
  var _filterV2On = isFilterV2Enabled();
  if (_filterV2On) {
    _lastCardCount = cards.length;
    var _facetMap = runAugmentation(cards);
    reportFilterDrift(_facetMap);
  }

  function productMatchesGender(pg, active) {
    if (active === 'all') return true;
    // S1 (facet-spec, approved 2026-07-03): unisex products appear under BOTH
    // gendered pills — a unisex scrub is wearable by everyone. Supersedes #173.
    return pg === active || pg === 'unisex';
  }

  // Normalize product data from either DOM card or AJAX JSON into a common shape
  function normalizeProduct(source, item) {
    var n = { gender: '', type: '', brand: '', sizes: [], lengths: [], colorFamilies: [], fabric: '', price: 0, collectionLine: '' };
    if (source === 'dom') {
      n.gender = item.dataset.productGender || '';
      n.type = item.dataset.productType || '';
      n.brand = item.dataset.brand || '';
      n.sizes = (item.dataset.sizes || '').toUpperCase().split(',').map(function(s) { return SIZE_ALIASES[s] || s; }).filter(Boolean);
      n.lengths = (item.dataset.lengths || '').split(',').filter(Boolean).map(mapLengthToFilterLabel);
      var dots = item.querySelectorAll('[data-card-color]');
      var colorSet = {};
      dots.forEach(function(d) { var f = getColorFamily(d.dataset.cardColor); if (f) colorSet[f] = true; });
      // Products on the "Prints" collection line should match the Print filter
      // regardless of how their swatch color names classify (most print patterns
      // resolve to their dominant solid color via getColorFamily).
      // W4 (#330 S7): Sanibel's line tag is 'Print' (singular) — accept both.
      if (['prints', 'print'].indexOf((item.dataset.collectionLine || '').toLowerCase()) !== -1) {
        colorSet['Print'] = true;
      }
      n.colorFamilies = Object.keys(colorSet);
      n.fabric = getFabric(item.dataset.collectionLine || '');
      n.collectionLine = item.dataset.collectionLine || ''; // #374: Prints type facet
      n.price = parseFloat(item.dataset.price) || 0;
    } else if (source === 'ajax') {
      var tags = (item.tags || []).map(function(t) { return t.toLowerCase(); });
      n.gender = getGenderFromTags(tags);
      n.type = getProductTypeFromTags(tags);
      n.brand = item.vendor || '';
      // Extract sizes/lengths/colors from IN-STOCK variants only (#166)
      var sizeOptIdx = -1, lenOptIdx = -1, colorOptIdx = -1;
      (item.options || []).forEach(function(o, i) {
        if (apOptionRole(o.name) === 'size') sizeOptIdx = i;
        else if (apOptionRole(o.name) === 'subsize') lenOptIdx = i;
        else if (apOptionRole(o.name) === 'color') colorOptIdx = i;
      });
      var seenS = {}, seenL = {}, cSet = {};
      (item.variants || []).forEach(function(v) {
        if (!v.available) return;
        if (sizeOptIdx !== -1) {
          var sv = v['option' + (sizeOptIdx + 1)];
          if (sv && !seenS[sv]) { seenS[sv] = true; var u = sv.toUpperCase(); n.sizes.push(SIZE_ALIASES[u] || u); }
        }
        if (lenOptIdx !== -1) {
          var lv = v['option' + (lenOptIdx + 1)];
          if (lv && !seenL[lv]) { seenL[lv] = true; n.lengths.push(mapLengthToFilterLabel(lv)); }
        }
        if (colorOptIdx !== -1) {
          var cv = v['option' + (colorOptIdx + 1)];
          if (cv) { var f = getColorFamily(cv); if (f && !cSet[f]) { cSet[f] = true; n.colorFamilies.push(f); } }
        }
      });
      var collTag = getCollectionTagRaw(item.tags || []);
      n.fabric = getFabric(collTag);
      n.collectionLine = collTag || ''; // #374: Prints type facet
      // Mirror DOM-path behaviour: products on the "Prints"/"Print" line match the Print filter (W4: singular = Sanibel)
      if (['prints', 'print'].indexOf((collTag || '').toLowerCase()) !== -1 && n.colorFamilies.indexOf('Print') === -1) {
        n.colorFamilies.push('Print');
      }
      // Use min variant price (matches DOM dataset.price = product.price_min/100).
      // First-variant-price gave wrong bucket assignments when v[0] was full price
      // but cheaper variants existed in another bucket.
      var _minP = Infinity;
      for (var _vi = 0; _vi < (item.variants || []).length; _vi++) {
        var _vp = parseFloat(item.variants[_vi].price);
        if (!isNaN(_vp) && _vp < _minP) _minP = _vp;
      }
      n.price = isFinite(_minP) ? _minP : 0;
    }
    return n;
  }

  // Check if a normalized product matches a specific filter category's selected values
  function productMatchesCategory(p, cat, vals) {
    if (!vals || vals.length === 0) return true;
    switch (cat) {
      case 'type': return typeMatches(vals, p.type, p.collectionLine); // #374
      case 'brand': return vals.indexOf(p.brand) !== -1;
      case 'size': return vals.some(function(s) { return cardSizesMatchFilter(p.sizes, s); });
      case 'length': return vals.some(function(l) { return p.lengths.indexOf(l) !== -1; });
      case 'color': return vals.some(function(c) { return p.colorFamilies.indexOf(c) !== -1; });
      case 'fabric': return vals.indexOf(p.fabric) !== -1;
      case 'price':
        return vals.some(function(range) {
          var parts = range.split('-');
          var bMin = parseFloat(parts[0]);
          var bMax = parseFloat(parts[1]);
          return p.price >= bMin && p.price < bMax;
        });
      default: return true;
    }
  }

  // Mark which price range bucket the displayed price falls into
  function markPriceRange(obj, price) {
    var ranges = [['0-10', 0, 10], ['10-20', 10, 20], ['20-30', 20, 30], ['30-999', 30, 999]];
    for (var i = 0; i < ranges.length; i++) {
      if (price >= ranges[i][1] && price < ranges[i][2]) { obj[ranges[i][0]] = true; return; }
    }
  }

  // Single-pass faceted filter computation: for each category, apply all OTHER
  // active filters and count which options have matching products. #166
  function computeAvailableOptions(products, filters, gender) {
    var categories = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    var available = {};
    categories.forEach(function(cat) { available[cat] = {}; });

    for (var pi = 0; pi < products.length; pi++) {
      var p = products[pi];
      // Gender pre-check (applies to all categories)
      if (!productMatchesGender(p.gender, gender)) continue;

      for (var ci = 0; ci < categories.length; ci++) {
        var cat = categories[ci];
        // Check if product passes ALL OTHER filters (excluding current category)
        var passes = true;
        for (var oi = 0; oi < categories.length; oi++) {
          if (oi === ci) continue;
          var otherCat = categories[oi];
          if (!filters[otherCat] || filters[otherCat].length === 0) continue;
          if (!productMatchesCategory(p, otherCat, filters[otherCat])) { passes = false; break; }
        }
        if (!passes) continue;

        // Mark this product's values as available
        switch (cat) {
          case 'type':
            if (p.type) available.type[p.type] = true;
            // #374: print-line membership also makes the 'Prints' option available
            if (isPrintLine(p.collectionLine)) available.type[PRINT_TYPE_VALUE] = true;
            break;
          case 'brand': if (p.brand) available.brand[p.brand] = true; break;
          case 'size': p.sizes.forEach(function(s) { available.size[s] = true; }); break;
          case 'length': p.lengths.forEach(function(l) { available.length[l] = true; }); break;
          case 'color': p.colorFamilies.forEach(function(c) { available.color[c] = true; }); break;
          case 'fabric': if (p.fabric) available.fabric[p.fabric] = true; break;
          case 'price': markPriceRange(available.price, p.price); break;
        }
      }
    }
    return available;
  }

  var _isInitialLoad = true;

  // Hide/show filter options based on cascading availability. #166
  // Only hide options when we have full AJAX data, OR the collection is not
  // paginated (all products loaded on page 1). Phase 1 DOM scan on paginated
  // collections is incomplete — don't hide based on partial data.
  function updateOptionVisibility(available) {
    var filterNames = ['type', 'brand', 'size', 'length', 'fabric', 'price'];
    var needsReapply = false;
    var hasPagination = document.querySelector('[data-load-more-wrap]');
    var canHide = !!cachedProducts || !hasPagination;

    filterNames.forEach(function(name) {
      var dropdown = document.querySelector('[data-filter-dropdown="' + name + '"]');
      if (!dropdown) return;
      dropdown.querySelectorAll('.s-filter__option').forEach(function(opt) {
        var cb = opt.querySelector('input[type="checkbox"]');
        if (!cb) return;
        var value = cb.value;
        // Length: hidden Short handled by combo; Petite checks combined availability
        if (name === 'length' && value === 'Short') return;
        // #374: Prints is tag-driven (COLLECTION:Prints), not derivable from the
        // rendered DOM's data-product-type. On paginated collections page 1 may
        // contain zero print products purely because of sort order — dimming it
        // there would suppress the click and break discovery. Mirrors the
        // COLOR › Print guard (FIX-CA-PRINTS-2026-05-19). Always keep clickable;
        // let the AJAX-all-pages fetch decide whether it yields results.
        if (name === 'type' && value === PRINT_TYPE_VALUE) {
          opt.removeAttribute('data-unavailable');
          opt.style.display = '';
          return;
        }
        var lookupValue = value;
        if (name === 'length' && value === 'Petite') lookupValue = 'Petite / Short';
        // Size: also check letter→numeric mapping
        var isAvailable = false;
        if (name === 'size') {
          // A size option is available if any product has a matching size via cardSizesMatchFilter
          isAvailable = available.size && (available.size[value.toUpperCase()] || false);
          // Also check if any numeric size in this letter's range is available
          if (!isAvailable && LETTER_TO_NUMERIC[value.toUpperCase()]) {
            var re = LETTER_TO_NUMERIC[value.toUpperCase()];
            for (var k in available.size) {
              if (re.test(k)) { isAvailable = true; break; }
            }
          }
        } else {
          isAvailable = available[name] && available[name][lookupValue];
        }

        if (isAvailable || cb.checked) {
          // Selected options always stay visible + active so the user can
          // see "0 products" feedback and uncheck themselves.
          opt.removeAttribute('data-unavailable');
          opt.style.display = '';
        } else if (canHide) {
          // #296 T2: dim instead of hide. CSS owns the visual via [data-unavailable].
          opt.setAttribute('data-unavailable', 'true');
        }
      });
    });

    // Color filter (dynamically rendered by color-map.js)
    var colorTarget = document.querySelector('[data-color-filter-target]');
    if (colorTarget) {
      colorTarget.querySelectorAll('.s-filter__color-option').forEach(function(opt) {
        var cb = opt.querySelector('input[name="filter_color"]');
        if (!cb) return;
        // Print is tag-driven (COLLECTION:Prints), not derivable from rendered DOM
        // swatch colors. On paginated collections (e.g. /collections/all), page 1
        // may contain zero print products purely because of sort order, even when
        // 28+ print products exist in the catalog. Marking Print unavailable in
        // that case suppresses the click and breaks discovery. Always keep Print
        // clickable; let the AJAX-all-pages fetch (fetchAndFilterAll) decide
        // whether the filter actually produces results.
        if (cb.value === 'Print') {
          // FIX-CA-PRINTS-2026-05-19
          opt.removeAttribute('data-unavailable');
          opt.style.display = '';
          return;
        }
        var isColorAvailable = available.color && available.color[cb.value];
        if (isColorAvailable || cb.checked) {
          // Selected color stays visible + active even if 0 products match —
          // prevents the auto-uncheck regression where Print would silently
          // disappear after selection.
          opt.removeAttribute('data-unavailable');
          opt.style.display = '';
        } else if (canHide) {
          // #296 T2: dim instead of hide. CSS owns the visual via [data-unavailable].
          opt.setAttribute('data-unavailable', 'true');
        }
      });
    }

    return needsReapply;
  }

  // Run cascading computation using best available data source. #166
  var _normalizedCache = null;
  var _cascadingInProgress = false; // Re-entrancy guard
  function runCascading() {
    if (_cascadingInProgress) return; // Prevent infinite loop: runCascading→applyFilters→runCascading
    _cascadingInProgress = true;

    var filters = {
      type: getCheckedValues('type'),
      brand: getCheckedValues('brand'),
      size: getCheckedValues('size'),
      length: getCheckedValues('length'),
      color: getCheckedValues('color'),
      fabric: getCheckedValues('fabric'),
      price: getCheckedValues('price')
    };

    var products;
    if (cachedProducts) {
      // Phase 2/2b: use full AJAX data
      if (!_normalizedCache) {
        _normalizedCache = cachedProducts.map(function(p) { return normalizeProduct('ajax', p); });
      }
      products = _normalizedCache;
    } else {
      // Phase 1: DOM cards only.
      products = [];
      cards.forEach(function(card) {
        if (card.dataset.hiddenByColorMatch === 'true') return;
        products.push(normalizeProduct('dom', card));
      });
    }

    var available = computeAvailableOptions(products, filters, activeGender);
    var needsReapply = updateOptionVisibility(available);
    // Rebuild mobile drawer so it reflects updated option visibility (#166)
    if (typeof buildDrawerBody === 'function') buildDrawerBody();
    _cascadingInProgress = false;
    // If we auto-unchecked any options, re-apply filters
    if (needsReapply) applyFilters();
  }

  // --- Dropdown open/close ---

  function openDropdown(name) {
    if (openDropdownEl) closeDropdown();
    var btn = document.querySelector('[data-filter-trigger="' + name + '"]');
    var panel = document.querySelector('[data-filter-panel="' + name + '"]');
    if (!btn || !panel) return;
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    openDropdownEl = name;
    if (window.innerWidth < 768 && backdrop) {
      backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDropdown() {
    if (!openDropdownEl) return;
    var btn = document.querySelector('[data-filter-trigger="' + openDropdownEl + '"]');
    var panel = document.querySelector('[data-filter-panel="' + openDropdownEl + '"]');
    if (btn) { btn.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    if (panel) panel.classList.remove('is-open');
    openDropdownEl = null;
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // Trigger buttons
  document.querySelectorAll('[data-filter-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var name = btn.getAttribute('data-filter-trigger');
      if (openDropdownEl === name) { closeDropdown(); } else { openDropdown(name); }
    });
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (openDropdownEl && !e.target.closest('.s-filter__dropdown')) closeDropdown();
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && openDropdownEl) closeDropdown();
  });

  // Backdrop click closes
  if (backdrop) backdrop.addEventListener('click', closeDropdown);

  // Mobile "VIEW ITEMS" close buttons
  document.querySelectorAll('[data-filter-close]').forEach(function(btn) {
    btn.addEventListener('click', closeDropdown);
  });

  // --- Gender pills ---

  var genderContainer = document.querySelector('[data-gender-filter]');
  var activeGender = 'all';

  if (genderContainer) {
    genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        activeGender = btn.dataset.genderBtn;
        genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.genderBtn === activeGender);
        });
        applyFilters();
      });
    });
  }

  // --- Apply filters ---

  function getCheckedValues(name) {
    var checked = [];
    document.querySelectorAll('input[name="filter_' + name + '"]:checked').forEach(function(cb) {
      checked.push(cb.value);
    });
    return checked;
  }

  // W1 (#330): explicit loading / error states. The pre-Stage-2 code showed an
  // interim DOM-filtered guess (wrong count + wrong subset) until the AJAX
  // correction landed — or forever, when the fetch failed (audit bugs B1/B2/B4/B7).
  function showFilterLoading() {
    if (grid) grid.style.display = 'none';
    var _ag = document.querySelector('[data-ajax-grid]');
    if (_ag) _ag.style.display = 'none';
    if (noResults) {
      noResults.innerHTML = '<p>Loading results…</p>';
      noResults.style.display = '';
    }
  }

  function showFilterError() {
    if (grid) grid.style.display = 'none';
    var _ag = document.querySelector('[data-ajax-grid]');
    if (_ag) _ag.style.display = 'none';
    if (countEl) countEl.textContent = '';
    if (noResults) {
      noResults.innerHTML = '<p>Couldn\'t load results.</p><button type="button" class="s-collection__clear-all-btn" data-filter-retry>Retry</button>';
      noResults.style.display = '';
      var _rb = noResults.querySelector('[data-filter-retry]');
      if (_rb) _rb.addEventListener('click', function() {
        showFilterLoading();
        fetchAndFilterAll();
      });
    }
  }

  function applyFilters() {
    // Race-condition guard (#106): invalidate any in-flight AJAX fetch from
    // a prior applyFilters() call. Without this, rapid taps on gender/type
    // pills can let stale fetches complete and render the wrong filter state
    // over the top of the current one. The fetchGeneration check in
    // fetchAndFilterAll (line ~1709) discards any response whose captured
    // generation doesn't match the current one.
    fetchGeneration++;

    // #224: Re-query cards to include any appended by server-side Load More.
    // querySelectorAll returns a static NodeList — cards added after the initial
    // query are invisible to the filter. Scope to the original grid so AJAX-
    // rendered cards (in [data-ajax-grid]) are not double-processed.
    cards = grid ? grid.querySelectorAll('[data-product-card]') : document.querySelectorAll('[data-product-card]');

    // #296 T1.5: re-augment when card count changes (Load More / AJAX brought
    // new vendors that weren't visible at init). Idempotent via existence check,
    // so harmless even if it runs every applyFilters call.
    if (_filterV2On && cards.length !== _lastCardCount) {
      _lastCardCount = cards.length;
      var _newFacetMap = runAugmentation(cards);
      reportFilterDrift(_newFacetMap);
    }

    // Ensure originalSrc is set for any newly-appended cards (needed for
    // color filter image reset).
    cards.forEach(function(card) {
      if (!card.dataset.originalSrc) {
        var img = card.querySelector('[data-card-image]');
        if (img) card.dataset.originalSrc = img.src;
      }
    });

    var types = getCheckedValues('type');
    var brands = getCheckedValues('brand');
    var sizes = getCheckedValues('size');
    var lengths = getCheckedValues('length');
    var colors = getCheckedValues('color');
    var fabrics = getCheckedValues('fabric');
    var prices = getCheckedValues('price');

    var visible = 0;
    cards.forEach(function(card) {
      // Skip cards already hidden by collection color match
      if (card.dataset.hiddenByColorMatch === 'true') { card.style.display = 'none'; return; }

      var show = true;

      // Gender — own gender OR unisex (S1, supersedes #173 strict match)
      if (activeGender !== 'all') {
        var g = card.dataset.productGender || '';
        if (g !== activeGender && g !== 'unisex') show = false;
      }

      // Product type
      if (show && types.length > 0) {
        var cardType = card.dataset.productType || '';
        // #374: typeMatches also grants 'Prints' via the COLLECTION:Prints line
        if (!typeMatches(types, cardType, card.dataset.collectionLine)) show = false;
      }

      // Brand
      if (show && brands.length > 0) {
        var cardBrand = card.dataset.brand || '';
        if (brands.indexOf(cardBrand) === -1) show = false;
      }

      // Size (OR logic: show if card has ANY selected size, with alias normalization
      // and letter→numeric mapping — see cardSizesMatchFilter / #140)
      if (show && sizes.length > 0) {
        var cardSizes = (card.dataset.sizes || '').toUpperCase().split(',');
        var normalizedCardSizes = cardSizes.map(function(s) { return SIZE_ALIASES[s] || s; });
        var hasSize = sizes.some(function(s) { return cardSizesMatchFilter(normalizedCardSizes, s); });
        if (!hasSize) show = false;
      }

      // Length (OR logic)
      if (show && lengths.length > 0) {
        var cardLengths = (card.dataset.lengths || '').split(',');
        var hasLength = lengths.some(function(l) { return cardLengths.indexOf(l) !== -1; });
        if (!hasLength) show = false;
      }

      // Color (OR logic: show if card has ANY color in selected families)
      var dots = card.querySelectorAll('[data-card-color]');
      if (show && colors.length > 0) {
        var hasColor = false;
        var matchedDotWithImg = null; // first matching dot that HAS an image URL
        var matchedDotAny = null;     // first matching dot regardless of image
        for (var d = 0; d < dots.length; d++) {
          var family = getColorFamily(dots[d].dataset.cardColor);
          if (colors.indexOf(family) !== -1) {
            hasColor = true;
            if (!matchedDotAny) matchedDotAny = dots[d];
            if (!matchedDotWithImg && dots[d].dataset.imageUrl) matchedDotWithImg = dots[d];
          }
        }
        // W5 (#330): Prints-line membership grants 'Print' — this parity rule
        // existed in the AJAX paths but was missing here (DOM path), so print
        // products vanished from the Print filter on unpaginated collections.
        if (!hasColor && colors.indexOf('Print') !== -1) {
          var _cardLine = (card.dataset.collectionLine || '').toLowerCase();
          if (_cardLine === 'prints' || _cardLine === 'print') hasColor = true;
        }
        if (!hasColor) show = false;
        // #224 fix: Always filter swatch visibility when a color is matched,
        // even if no matching dot has a data-image-url. Previously, the entire
        // block was gated on matchedDot (which required imageUrl), leaving
        // non-matching swatches visible for cards without variant images.
        if (show && matchedDotAny) {
          // Swap card image to the matching color if an image URL exists
          if (matchedDotWithImg) {
            var cImg = card.querySelector('[data-card-image]');
            if (cImg && matchedDotWithImg.dataset.imageUrl) {
              cImg.src = matchedDotWithImg.dataset.imageUrl;
              cImg.srcset = matchedDotWithImg.dataset.imageUrl.replace('width=600', 'width=300') + ' 300w, ' + matchedDotWithImg.dataset.imageUrl + ' 600w';
            }
          }
          // Show only matching color swatches, hide the rest
          dots.forEach(function(dd) {
            dd.classList.remove('is-active');
            var ddFamily = getColorFamily(dd.dataset.cardColor);
            dd.style.display = colors.indexOf(ddFamily) !== -1 ? '' : 'none';
          });
          (matchedDotWithImg || matchedDotAny).classList.add('is-active');
          // #226 WYSIWYG: Update price, badge, and link for the filtered color
          var pricingDot = matchedDotWithImg || matchedDotAny;
          updateCardPricingFromDot(card, pricingDot);
        }
      } else if (colors.length === 0) {
        // No color filter — restore original state (image, price, badge, link)
        if (card.dataset.originalSrc) {
          var oImg = card.querySelector('[data-card-image]');
          if (oImg && oImg.src !== card.dataset.originalSrc) {
            oImg.src = card.dataset.originalSrc;
            oImg.srcset = card.dataset.originalSrc.replace('width=600', 'width=300') + ' 300w, ' + card.dataset.originalSrc + ' 600w';
          }
        }
        // #226: Restore original price, badge, link, and data-price
        if (card.dataset.originalPriceHtml !== undefined) {
          var oPriceEl = card.querySelector('.s-product-card__price');
          if (oPriceEl) oPriceEl.innerHTML = card.dataset.originalPriceHtml;
        }
        var oBadgeEl = card.querySelector('.s-product-card__badge');
        if (oBadgeEl && card.dataset.originalBadgeHtml !== undefined) {
          oBadgeEl.innerHTML = card.dataset.originalBadgeHtml;
          oBadgeEl.style.display = card.dataset.originalBadgeDisplay || '';
        }
        if (card.dataset.originalHref !== undefined) {
          var oLink = card.querySelector('[data-card-link]');
          if (oLink) oLink.setAttribute('href', card.dataset.originalHref);
        }
        if (card.dataset.originalDataPrice !== undefined) {
          card.dataset.price = card.dataset.originalDataPrice;
        }
        dots.forEach(function(dd) { dd.classList.remove('is-active'); dd.style.display = ''; });
      }

      // Fabric
      if (show && fabrics.length > 0) {
        var cardFabric = getFabric(card.dataset.collectionLine);
        if (!cardFabric || fabrics.indexOf(cardFabric) === -1) show = false;
      }

      // Price (OR logic: show if displayed price falls in ANY selected range).
      // Fix #166: use data-price (the displayed/featured variant price) instead
      // of data-price-min/max range overlap. A customer selecting "$10-$20"
      // expects to see products DISPLAYED at $10-$20, not products that have
      // some variant in that range but display at $24.99.
      if (show && prices.length > 0) {
        var cardPrice = parseFloat(card.dataset.price) || 0;
        var hasPrice = prices.some(function(range) {
          var parts = range.split('-');
          var bMin = parseFloat(parts[0]);
          var bMax = parseFloat(parts[1]);
          return cardPrice >= bMin && cardPrice < bMax;
        });
        if (!hasPrice) show = false;
      }

      card.style.display = show ? '' : 'none';
      if (show) visible++;

      // Filter-aware variant link (#167): update card link to point to variant
      // matching the active size/length/color filters so PDP lands on what the
      // customer filtered for.
      if (show && (sizes.length > 0 || lengths.length > 0)) {
        var varJsonStr = card.dataset.variantsJson;
        var optNames = (card.dataset.optionNames || '').split(',');
        if (varJsonStr) {
          try {
            var vars = JSON.parse(varJsonStr);
            var sIdx = apOptionIndex(optNames, 'size');
            var lIdx = apOptionIndex(optNames, 'subsize');
            var cIdx = apOptionIndex(optNames, 'color');
            var best = null;
            for (var vi = 0; vi < vars.length; vi++) {
              var v = vars[vi];
              // Check size match
              if (sizes.length > 0 && sIdx !== -1) {
                var vs = v['o' + (sIdx + 1)] || '';
                var vsNorm = vs.toUpperCase();
                vsNorm = SIZE_ALIASES[vsNorm] || vsNorm;
                if (!sizes.some(function(s) { return cardSizesMatchFilter([vsNorm], s); })) continue;
              }
              // Check length match
              if (lengths.length > 0 && lIdx !== -1) {
                var vl = v['o' + (lIdx + 1)] || '';
                if (lengths.indexOf(vl) === -1) continue;
              }
              // Check color match (if color filter also active)
              if (colors.length > 0 && cIdx !== -1) {
                var vc = v['o' + (cIdx + 1)] || '';
                if (colors.indexOf(getColorFamily(vc)) === -1) continue;
              }
              best = v;
              break;
            }
            if (best) {
              var cLink = card.querySelector('[data-card-link]');
              if (cLink) {
                var baseUrl = cLink.getAttribute('href').split('?')[0];
                cLink.setAttribute('href', baseUrl + '?variant=' + best.id);
              }
            }
          } catch(e) { /* malformed JSON — skip */ }
        }
      }
    });

    // Update count
    var hasPagination = document.querySelector('[data-load-more-wrap]');
    // W1 (#330 B7/B2): on paginated collections with filters active, the DOM-only
    // count over the first 48 SSR cards is WRONG data. Never show it — show a
    // neutral loading state; the AJAX result is the only state customers see.
    var awaitingAjax = hasPagination && hasAnyFilter();
    if (countEl) {
      if (!hasAnyFilter()) {
        countEl.textContent = originalCountText;
      } else if (awaitingAjax) {
        countEl.textContent = '…';
      } else {
        countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
      }
    }

    // Show/hide no-results message
    if (awaitingAjax) {
      // Paginated collection with active filters — AJAX fetch all pages for accurate count/results
      showFilterLoading();
      clearTimeout(fetchDebounceTimer);
      fetchDebounceTimer = setTimeout(fetchAndFilterAll, 200);
      // #224: Hide server-side Load More immediately so it can't fire unfiltered
      // page loads during the 200ms debounce or AJAX fetch window. The AJAX path
      // (renderAjaxBatch) re-shows it with its own handler once results arrive.
      hasPagination.style.display = 'none';
    } else {
      // Transitioning to no-filter state — cancel any pending debounced fetch
      // so it doesn't fire with stale filter state (#106)
      clearTimeout(fetchDebounceTimer);
      if (noResults) noResults.style.display = visible === 0 ? '' : 'none';
      if (grid) grid.style.display = visible === 0 ? 'none' : '';
      // Remove any AJAX-rendered cards and restore original grid
      var ajaxGrid = document.querySelector('[data-ajax-grid]');
      if (ajaxGrid) ajaxGrid.remove();
      if (visible > 0 && grid) grid.style.display = '';
      // Restore pagination when no filters active
      if (!hasAnyFilter() && hasPagination) {
        hasPagination.style.display = '';
      } else if (hasPagination) {
        hasPagination.style.display = 'none';
      }
    }

    updateFilterCounts();
    updateActiveTags();
    persistFiltersToURL();
    if (typeof updateDrawerCount === 'function') updateDrawerCount();
    if (typeof updateMoreBadge === 'function') updateMoreBadge();
    if (typeof updateMobileTags === 'function') updateMobileTags();
    if (typeof updateMobileCount === 'function') updateMobileCount();

    // Cascading filter: update option visibility based on current filter state (#166)
    runCascading();
  }

  function hasAnyFilter() {
    if (activeGender !== 'all') return true;
    var filterTypes = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    for (var i = 0; i < filterTypes.length; i++) {
      if (getCheckedValues(filterTypes[i]).length > 0) return true;
    }
    return false;
  }

  // Build color swatch HTML for AJAX-rendered product cards.
  // Mirrors the structure from product-card.liquid (lines 215-271).
  function buildSwatchesHtml(product, activeColors) {
    var colorOpt = null;
    (product.options || []).forEach(function(o) { if (apOptionRole(o.name) === 'color') colorOpt = o; });
    if (!colorOpt || !colorOpt.values || colorOpt.values.length === 0) return '';

    var colorValues = colorOpt.values;

    // Build a map: color → { imgSrc, variantId, price, comparePrice } from first matching variant.
    // #226: Include pricing so swatch clicks use updateCardPricingFromDot (no fetch needed).
    var colorData = {};
    (product.variants || []).forEach(function(v) {
      var c = v.option1;
      if (!c || colorData[c]) return;
      var imgSrc = '';
      if (v.featured_image) {
        imgSrc = typeof v.featured_image === 'string' ? v.featured_image : (v.featured_image.src || '');
      }
      if (imgSrc) imgSrc = imgSrc.replace(/(\.[^.]+)$/, '_600x$1');
      var isAvail = v.available !== false;
      colorData[c] = {
        imgSrc: imgSrc,
        variantId: isAvail ? v.id : '',
        price: isAvail ? v.price : '',
        comparePrice: isAvail && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price) ? v.compare_at_price : ''
      };
    });

    // When a color filter is active, only render matching dots (non-matching are
    // omitted entirely). This avoids CSS nth-of-type rules hiding matching dots
    // that happen to be at high DOM positions.
    var renderColors = colorValues;
    if (activeColors.length > 0) {
      renderColors = colorValues.filter(function(c) {
        return activeColors.indexOf(getColorFamily(c)) !== -1;
      });
    }

    var visibleCount = renderColors.length;
    var mobileVisible = 4;
    var desktopVisible = 6;
    var mobileOverflow = visibleCount - mobileVisible;
    var desktopOverflow = visibleCount - desktopVisible;
    var showMobileBadge = mobileOverflow > 0;
    var showDesktopBadge = desktopOverflow > 0;

    var firstMatchSet = false;
    var dotsHtml = renderColors.map(function(color) {
      var cd = colorData[color] || { imgSrc: '', variantId: '', price: '', comparePrice: '' };
      var isActive = false;
      if (activeColors.length > 0 && !firstMatchSet) { isActive = true; firstMatchSet = true; }
      var activeCls = isActive ? ' is-active' : '';
      var esc = color.replace(/"/g, '&quot;').replace(/'/g, '&#39;');

      return '<button type="button" class="s-product-card__dot' + activeCls + '"' +
        ' data-color-name="' + esc + '"' +
        ' data-card-color="' + esc + '"' +
        (cd.imgSrc ? ' data-image-url="' + cd.imgSrc + '"' : '') +
        (cd.variantId ? ' data-variant-id="' + cd.variantId + '"' : '') +
        (cd.price ? ' data-swatch-price="' + cd.price + '"' : '') +
        (cd.comparePrice ? ' data-swatch-compare="' + cd.comparePrice + '"' : '') +
        ' title="' + esc + '"' +
        ' aria-label="Select ' + esc + ' color"' +
        '><svg class="s-product-card__check" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4"><polyline points="20 6 9 17 4 12"/></svg></button>';
    }).join('');

    // Overflow badge
    var badgeHtml = '';
    if (showMobileBadge || showDesktopBadge) {
      var badgeHref = '/products/' + product.handle;
      badgeHtml = '<a href="' + badgeHref + '" class="s-product-card__more" data-card-more aria-label="View all ' + colorValues.length + ' colors">';
      if (showMobileBadge) badgeHtml += '<span class="s-product-card__more-count s-product-card__more-count--mobile">+' + mobileOverflow + '</span>';
      if (showDesktopBadge) badgeHtml += '<span class="s-product-card__more-count s-product-card__more-count--desktop">+' + desktopOverflow + '</span>';
      badgeHtml += '</a>';
    }

    return '<div class="s-product-card__colors" data-card-colors' +
      (showMobileBadge ? ' data-mobile-overflow' : '') +
      (showDesktopBadge ? ' data-desktop-overflow' : '') +
      '>' + dotsHtml + badgeHtml + '</div>';
  }

  function filterAndRenderProducts(allProducts) {
    var types = getCheckedValues('type');
    var brands = getCheckedValues('brand');
    var sizes = getCheckedValues('size');
    var lengths = getCheckedValues('length');
    var colors = getCheckedValues('color');
    var fabrics = getCheckedValues('fabric');
    var prices = getCheckedValues('price');

    var products = allProducts.filter(function(p) {
      var tags = (p.tags || []).map(function(t) { return t.toLowerCase(); });

      // Gender — own gender OR unisex (S1, supersedes #173 strict match)
      if (activeGender !== 'all') {
        var pg = getGenderFromTags(tags);
        if (pg !== activeGender && pg !== 'unisex') return false;
      }

      // Product type (uses extracted getProductTypeFromTags — #166)
      if (types.length > 0) {
        var pt = getProductTypeFromTags(tags);
        // #374: mirror the DOM path — COLLECTION:Prints grants the 'Prints' type
        if (!typeMatches(types, pt, getCollectionTagRaw(p.tags || []))) return false;
      }

      // Brand
      if (brands.length > 0) {
        if (brands.indexOf(p.vendor) === -1) return false;
      }

      // Size (letter→numeric mapping — see #140)
      // Fix #166: only consider sizes from IN-STOCK variants
      if (sizes.length > 0) {
        var sizeOptIdx = -1;
        (p.options || []).forEach(function(o, i) { if (apOptionRole(o.name) === 'size') sizeOptIdx = i; });
        var pSizes = [];
        if (sizeOptIdx !== -1 && p.variants) {
          var seenSizes = {};
          p.variants.forEach(function(v) {
            if (!v.available) return;
            var sv = v['option' + (sizeOptIdx + 1)];
            if (sv && !seenSizes[sv]) { seenSizes[sv] = true; pSizes.push(sv); }
          });
        }
        var normalizedSizes = pSizes.map(function(s) { var u = s.toUpperCase(); return SIZE_ALIASES[u] || u; });
        var hasSize = sizes.some(function(s) { return cardSizesMatchFilter(normalizedSizes, s); });
        if (!hasSize) return false;
      }

      // Length/Subsize — only consider lengths from IN-STOCK variants (#166)
      if (lengths.length > 0) {
        var lenOptIdx = -1;
        (p.options || []).forEach(function(o, i) { if (apOptionRole(o.name) === 'subsize') lenOptIdx = i; });
        var pLengths = [];
        if (lenOptIdx !== -1 && p.variants) {
          var seenLens = {};
          p.variants.forEach(function(v) {
            if (!v.available) return;
            var lv = v['option' + (lenOptIdx + 1)];
            if (lv && !seenLens[lv]) { seenLens[lv] = true; pLengths.push(lv); }
          });
        }
        var hasLength = lengths.some(function(l) { return pLengths.indexOf(l) !== -1; });
        if (!hasLength) return false;
      }

      // Color
      if (colors.length > 0) {
        var pColors = [];
        (p.options || []).forEach(function(o) { if (apOptionRole(o.name) === 'color') pColors = o.values; });
        var hasColor = pColors.some(function(c) { return colors.indexOf(getColorFamily(c)) !== -1; });
        // Mirror normalizeProduct/AJAX behaviour: COLLECTION:Prints products match
        // the 'Print' color filter even if their variant color names resolve to
        // their dominant solid color (e.g. "Llama Momma" → Pink via printGroups).
        if (!hasColor && colors.indexOf('Print') !== -1) {
          var _collTag = getCollectionTagRaw(p.tags || []);
          if (['prints', 'print'].indexOf((_collTag || '').toLowerCase()) !== -1) hasColor = true;
        }
        if (!hasColor) return false;
      }

      // Fabric
      if (fabrics.length > 0) {
        var collTag = getCollectionTagRaw(p.tags || []);
        var pFabric = getFabric(collTag);
        if (!pFabric || fabrics.indexOf(pFabric) === -1) return false;
      }

      // Price (OR logic: min variant price in ANY selected range).
      // Cards display product.price_min (set by Liquid as dataset.price). AJAX
      // must match the same anchor or filter results contradict what users see.
      // Earlier #166 chose variants[0].price but variants[0] is admin order, not
      // necessarily the cheapest — caused 19+ products to fall in wrong bucket.
      if (prices.length > 0) {
        var pPrice = Infinity;
        for (var _vi = 0; _vi < (p.variants || []).length; _vi++) {
          var _vp = parseFloat(p.variants[_vi].price);
          if (!isNaN(_vp) && _vp < pPrice) pPrice = _vp;
        }
        if (!isFinite(pPrice)) pPrice = 0;
        var hasPrice = prices.some(function(range) {
          var parts = range.split('-');
          var bMin = parseFloat(parts[0]);
          var bMax = parseFloat(parts[1]);
          return pPrice >= bMin && pPrice < bMax;
        });
        if (!hasPrice) return false;
      }

      return true;
    });

    // Render results
    if (products.length === 0) {
      if (noResults) {
        // Inject the empty-state with a fresh Clear All button. The previous
        // implementation replaced innerHTML (destroying the original
        // [data-clear-all-filters] button that had its click handler bound at
        // init) and used an inline onclick that searched for the destroyed
        // selector — click was a no-op. Bind the click directly to the
        // closure-scoped clearAllFilters() instead.
        noResults.innerHTML = '<p>No products match your filters.</p><button type="button" class="s-collection__clear-all-btn" data-no-results-clear>Clear all filters</button>';
        noResults.style.display = '';
        var nrClearBtn = noResults.querySelector('[data-no-results-clear]');
        if (nrClearBtn) nrClearBtn.addEventListener('click', clearAllFilters);
      }
      if (grid) grid.style.display = 'none';
      // W1 fix (B1, #330): a PREVIOUS filter's AJAX grid stayed visible under
      // the "0 products" label — 63 audit rows. Clear it too.
      var _zeroAjaxGrid = document.querySelector('[data-ajax-grid]');
      if (_zeroAjaxGrid) { _zeroAjaxGrid.innerHTML = ''; _zeroAjaxGrid.style.display = 'none'; }
      if (countEl) countEl.textContent = '0 products';
      if (typeof updateDrawerCount === 'function') updateDrawerCount();
      if (typeof updateMobileCount === 'function') updateMobileCount();
      return;
    }

    if (countEl) countEl.textContent = products.length + ' product' + (products.length !== 1 ? 's' : '');
    if (typeof updateDrawerCount === 'function') updateDrawerCount();
    if (typeof updateMobileCount === 'function') updateMobileCount();
    if (noResults) noResults.style.display = 'none';

    // #195: Store filtered products for paginated rendering
    ajaxFilteredProducts = products;
    ajaxRenderedCount = 0;

    // Build AJAX grid container
    var ajaxGrid = document.querySelector('[data-ajax-grid]');
    if (!ajaxGrid) {
      ajaxGrid = document.createElement('div');
      ajaxGrid.className = 's-collection__grid';
      ajaxGrid.setAttribute('data-ajax-grid', '');
      grid.parentNode.insertBefore(ajaxGrid, grid.nextSibling);
    }
    ajaxGrid.innerHTML = '';
    ajaxGrid.style.display = '';
    if (grid) grid.style.display = 'none';

    // Render first batch
    renderAjaxBatch(colors, sizes, lengths);

    // Phase 2 cascading: AJAX data is now available, recompute option visibility (#166)
    runCascading();
  }

  // #195: Render one batch of AJAX-filtered cards and manage Load More button
  function renderAjaxBatch(colors, sizes, lengths) {
    var ajaxGrid = document.querySelector('[data-ajax-grid]');
    if (!ajaxGrid) return;

    var batch = ajaxFilteredProducts.slice(ajaxRenderedCount, ajaxRenderedCount + AJAX_PAGE_SIZE);
    var html = batch.map(function(p) {
      // Fix #127 BUG #E: when a color filter is active, the AJAX card must show
      // the variant image matching the selected color family — not featured_image
      var matchedImg = '';
      var matchedVariantId = '';
      if (colors.length > 0 && p.variants && p.variants.length) {
        for (var vi = 0; vi < p.variants.length; vi++) {
          var vOpt1 = p.variants[vi].option1;
          if (vOpt1 && colors.indexOf(getColorFamily(vOpt1)) !== -1) {
            var vImg = p.variants[vi].featured_image;
            if (vImg && (typeof vImg === 'string' ? vImg : vImg.src)) {
              matchedImg = typeof vImg === 'string' ? vImg : vImg.src;
              matchedVariantId = p.variants[vi].id;
              break;
            }
          }
        }
      }
      var img = matchedImg || (p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '') : (p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : ''));
      if (img) img = img.replace(/(\.[^.]+)$/, '_600x$1');

      // First available variant scoped to active filters (#166/#167).
      var _sizeOptIdx = -1, _lenOptIdx = -1, _colorOptIdx = -1;
      (p.options || []).forEach(function(o, i) {
        if (apOptionRole(o.name) === 'size') _sizeOptIdx = i;
        else if (apOptionRole(o.name) === 'subsize') _lenOptIdx = i;
        else if (apOptionRole(o.name) === 'color') _colorOptIdx = i;
      });
      // #169: Prefer discounted variant for sale badge + strikethrough
      var firstAvailVariant = null;
      var firstDiscVariant = null;
      if (p.variants && p.variants.length) {
        for (var dvi = 0; dvi < p.variants.length; dvi++) {
          var dv = p.variants[dvi];
          if (dv.available === false) continue;
          if (colors.length > 0 && _colorOptIdx !== -1) {
            var dvColor = dv['option' + (_colorOptIdx + 1)];
            if (!dvColor || colors.indexOf(getColorFamily(dvColor)) === -1) continue;
          }
          if (sizes.length > 0 && _sizeOptIdx !== -1) {
            var dvSize = dv['option' + (_sizeOptIdx + 1)];
            if (!dvSize) continue;
            var dvSizeNorm = dvSize.toUpperCase();
            dvSizeNorm = SIZE_ALIASES[dvSizeNorm] || dvSizeNorm;
            if (!sizes.some(function(s) { return cardSizesMatchFilter([dvSizeNorm], s); })) continue;
          }
          if (lengths.length > 0 && _lenOptIdx !== -1) {
            var dvLen = dv['option' + (_lenOptIdx + 1)];
            if (!dvLen || lengths.indexOf(dvLen) === -1) continue;
          }
          if (!firstAvailVariant) firstAvailVariant = dv;
          if (!firstDiscVariant && dv.compare_at_price && parseFloat(dv.compare_at_price) > parseFloat(dv.price)) {
            firstDiscVariant = dv;
          }
          if (firstAvailVariant && firstDiscVariant) break;
        }
      }

      var displayVariant = firstDiscVariant || firstAvailVariant || (p.variants && p.variants[0]);
      var dvPrice = displayVariant ? parseFloat(displayVariant.price) : 0;
      var dvCompare = displayVariant && displayVariant.compare_at_price ? parseFloat(displayVariant.compare_at_price) : 0;
      var hasDiscount = dvCompare > dvPrice && dvCompare > 0;
      var priceHtml = '';
      var badgeHtml = '';
      if (hasDiscount) {
        // Floor to match Liquid `divided_by` in product-card.liquid:175.
        // Invariant: displayed % must never overstate the actual discount.
        var pct = Math.floor((dvCompare - dvPrice) / dvCompare * 100);
        priceHtml = '<s class="s-product-card__compare-price">$' + dvCompare.toFixed(2) + '</s> $' + dvPrice.toFixed(2);
        badgeHtml = '<span class="s-product-card__badge">' + pct + '% OFF</span>';
      } else {
        priceHtml = dvPrice ? '$' + dvPrice.toFixed(2) : '';
      }
      var cardVariantId = matchedVariantId || (displayVariant ? displayVariant.id : '');

      if (firstDiscVariant && !matchedImg && firstDiscVariant.featured_image) {
        var discImg = typeof firstDiscVariant.featured_image === 'string' ? firstDiscVariant.featured_image : firstDiscVariant.featured_image.src;
        if (discImg) {
          img = discImg.replace(/(\.[^.]+)$/, '_600x$1');
        }
      }

      var colTag = getCollectionTagRaw(p.tags || []);
      var ajaxUnisex = (p.tags || []).some(function(t) { return t.toLowerCase() === 'unisex'; });
      var linkHref = '/products/' + p.handle + (cardVariantId ? '?variant=' + cardVariantId : '');
      var swatchesHtml = buildSwatchesHtml(p, colors);
      var defaultImg = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '') : (p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : '');
      if (defaultImg) defaultImg = defaultImg.replace(/(\.[^.]+)$/, '_600x$1');
      var escTitle = (p.title || '').replace(/"/g, '&quot;');
      return '<div class="s-product-card" data-product-card data-original-src="' + defaultImg + '">' +
        '<a href="' + linkHref + '" class="s-product-card__link" data-card-link aria-label="' + escTitle + '"></a>' +
        '<div class="s-product-card__image-wrap">' + badgeHtml +
          (ajaxUnisex ? '<span class="s-product-card__unisex-badge" title="Unisex">&#x26A5;</span>' : '') +
          '<img src="' + img + '" alt="' + escTitle + '" class="s-product-card__image" data-card-image loading="lazy">' +
        '</div>' +
        '<div class="s-product-card__info">' +
          '<p class="s-product-card__vendor">' + (p.vendor || '') + (colTag ? ' <span class="s-product-card__collection-name">&middot; ' + colTag + '</span>' : '') + '</p>' +
          '<h3 class="s-product-card__title">' + (p.title || '').replace(p.vendor || '', '').replace(/\s{2,}/g, ' ').trim() + '</h3>' +
          '<p class="s-product-card__price">' + priceHtml + '</p>' +
          swatchesHtml +
        '</div></div>';
    }).join('');

    // Append batch (not replace — supports Load More)
    ajaxGrid.insertAdjacentHTML('beforeend', html);
    ajaxRenderedCount += batch.length;

    // Apply color hex values to new swatch dots
    if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) {
      AP_COLOR_MAP.applyAll();
    }

    // #195: Show/hide Load More based on remaining products
    var loadMoreWrap = document.querySelector('[data-load-more-wrap]');
    var loadMoreBtn = document.querySelector('[data-load-more]');
    if (ajaxRenderedCount < ajaxFilteredProducts.length) {
      // More products to show — display Load More with AJAX handler
      if (loadMoreWrap) {
        loadMoreWrap.style.display = '';
        if (loadMoreBtn) {
          // Replace server-side Load More handler with AJAX batch handler
          var newBtn = loadMoreBtn.cloneNode(true);
          loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);
          newBtn.addEventListener('click', function() {
            renderAjaxBatch(colors, sizes, lengths);
          });
        }
      }
    } else {
      // All products rendered — hide Load More
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
    }
  }

  function fetchAndFilterAll() {
    var collHandle = window.location.pathname.match(/\/collections\/([^/?]+)/);
    if (!collHandle) return;
    collHandle = collHandle[1];

    var sortParam = new URLSearchParams(window.location.search).get('sort_by') || '';

    // Check cache — skip fetch if same collection + sort
    if (cachedProducts && cachedCollHandle === collHandle && cachedSortBy === sortParam) {
      // W1 (B4): a render exception must surface as an error state, never a
      // silently-wrong grid.
      try { filterAndRenderProducts(cachedProducts); }
      catch (e) { console.error('[filter] render failed', e); showFilterError(); }
      return;
    }

    // Show loading state (single shared implementation — W1)
    showFilterLoading();

    // #224 fix: Paginate AJAX fetch instead of single limit=250 request.
    // Shopify products.json returns HTTP 500 when the response exceeds ~15MB
    // (our 237 products with variant images hit ~20MB at limit=250).
    // Fetch in pages of 100 which reliably stays under the size limit.
    var AJAX_FETCH_LIMIT = 100;
    var myGeneration = fetchGeneration;
    var allProducts = [];
    var page = 1;

    function fetchPage(attempt) {
      // Abort if filters were cleared while fetch was in-flight — the newer
      // applyFilters() call owns the UI from here (#106 generation guard).
      if (myGeneration !== fetchGeneration) return;

      var fetchUrl = '/collections/' + collHandle + '/products.json?limit=' + AJAX_FETCH_LIMIT + '&page=' + page;
      if (sortParam) fetchUrl += '&sort_by=' + sortParam;

      fetch(fetchUrl)
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(data) {
          if (myGeneration !== fetchGeneration) return;
          var products = data.products || [];
          allProducts = allProducts.concat(products);

          if (products.length === AJAX_FETCH_LIMIT) {
            // More pages may exist — fetch next
            page++;
            fetchPage(0);
          } else {
            // Last page reached — all products collected
            cachedProducts = allProducts;
            cachedCollHandle = collHandle;
            cachedSortBy = sortParam;
            _normalizedCache = null; // Invalidate so runCascading re-normalizes from fresh AJAX data (#166)
            // W1 (#330 B4): render OUTSIDE the fetch promise chain so a render
            // exception can't fall into the network catch below (which used to
            // permanently show the unfiltered grid + a fake "N+ products" count).
            setTimeout(function() {
              if (myGeneration !== fetchGeneration) return;
              try { filterAndRenderProducts(allProducts); }
              catch (e) { console.error('[filter] render failed', e); showFilterError(); }
            }, 0);
          }
        })
        .catch(function(err) {
          if (myGeneration !== fetchGeneration) return;
          // W1/W2 (#330 B4): retry with backoff long enough to ride out
          // Shopify products.json rate limiting (429/430), then an HONEST
          // error state. The old fallback restored the unfiltered grid and
          // wrote "N+ products" — wrong results disguised as success.
          var a = attempt || 0;
          var delays = [1500, 4000, 8000];
          if (a < delays.length) {
            setTimeout(function() { fetchPage(a + 1); }, delays[a]);
            return;
          }
          console.error('[filter] AJAX fetch failed after retries', err);
          showFilterError();
        });
    }

    fetchPage(0);
  }

  // --- Filter counts on buttons ---

  function updateFilterCounts() {
    var filterTypes = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    filterTypes.forEach(function(ft) {
      var checkedValues = getCheckedValues(ft);
      var count = checkedValues.length;
      // #301: Petite/Short is one combo option in the UI — collapse to 1 for badge
      if (ft === 'length' && checkedValues.indexOf('Petite') !== -1 && checkedValues.indexOf('Short') !== -1) {
        count = count - 1;
      }
      var badge = document.querySelector('[data-filter-count="' + ft + '"]');
      var btn = document.querySelector('[data-filter-trigger="' + ft + '"]');
      if (badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }
      // Toggle has-active class for visual emphasis
      if (btn) btn.classList.toggle('has-active', count > 0);
    });
  }

  // --- Active filter indicator (CLEAR ALL toggle + toast notifications) ---
  //
  // Chip pills were removed in favor of transient toasts. State is still
  // visible via dropdown count badges and the top-right CLEAR ALL link.
  // updateActiveTags() now:
  //   1. Computes hasAny from current state
  //   2. Toggles top-right [data-clear-all-top] visibility
  //   3. Diffs current vs previous snapshot → emits per-change toasts
  //   4. Stores current snapshot for next diff
  //
  // First call (page load / URL restore) emits no toasts — prev is null.
  // clearAllFilters() sets _suppressDiffToasts so a single "All filters
  // cleared" toast fires instead of one per cleared value.

  var _prevFilterSnapshot = null;
  var _suppressDiffToasts = false;
  var _toastFilterLabels = { type: 'Type', brand: 'Brand', size: 'Size', length: 'Length', color: 'Color', fabric: 'Fabric', price: 'Price' };

  function ensureToastContainer() {
    var c = document.querySelector('[data-toast-container]');
    if (!c) {
      c = document.createElement('div');
      c.className = 's-toast-container';
      c.setAttribute('data-toast-container', '');
      document.body.appendChild(c);
    }
    return c;
  }

  function showToast(message) {
    var c = ensureToastContainer();
    var t = document.createElement('div');
    t.className = 's-toast';
    t.setAttribute('role', 'status');
    t.textContent = message;
    c.appendChild(t);
    requestAnimationFrame(function() { t.classList.add('is-visible'); });
    setTimeout(function() {
      t.classList.remove('is-visible');
      setTimeout(function() { if (t.parentNode) t.remove(); }, 250);
    }, 2200);
  }

  function snapshotFilterState() {
    var snap = { gender: activeGender, values: {} };
    Object.keys(_toastFilterLabels).forEach(function(key) {
      snap.values[key] = getCheckedValues(key).slice();
    });
    return snap;
  }

  function diffAndToast(prev, curr) {
    return; // #301: filter toasts disabled per Matt 2026-05-19 — keep infra for future
    if (!prev) return; // skip first-call (page load / URL restore)
    if (prev.gender !== curr.gender) {
      showToast('Gender: ' + curr.gender.charAt(0).toUpperCase() + curr.gender.slice(1));
    }
    Object.keys(_toastFilterLabels).forEach(function(key) {
      var p = prev.values[key] || [];
      var c = curr.values[key] || [];
      c.forEach(function(v) {
        if (p.indexOf(v) === -1) showToast(_toastFilterLabels[key] + ': ' + chipLabel(key, v) + ' added');
      });
      p.forEach(function(v) {
        if (c.indexOf(v) === -1) showToast(_toastFilterLabels[key] + ': ' + chipLabel(key, v) + ' removed');
      });
    });
  }

  function updateActiveTags() {
    var hasAny = false;
    if (activeGender !== 'all') hasAny = true;
    Object.keys(_toastFilterLabels).forEach(function(key) {
      if (getCheckedValues(key).length > 0) hasAny = true;
    });

    var clearAllTop = document.querySelector('[data-clear-all-top]');
    if (clearAllTop) clearAllTop.style.display = hasAny ? '' : 'none';

    var curr = snapshotFilterState();
    if (_suppressDiffToasts) {
      _suppressDiffToasts = false;
      // #301: "All filters cleared" toast disabled per Matt 2026-05-19
    } else {
      diffAndToast(_prevFilterSnapshot, curr); // no-op after #301
    }
    _prevFilterSnapshot = curr;
  }

  // --- Clear all ---

  function clearAllFilters() {
    // Cancel any pending or in-flight AJAX fetch
    clearTimeout(fetchDebounceTimer);
    fetchGeneration++;
    cachedProducts = null;

    // Tell updateActiveTags to emit a single "All filters cleared" toast
    // instead of one per cleared value (read+reset inside updateActiveTags).
    _suppressDiffToasts = true;

    activeGender = 'all';
    if (genderContainer) {
      genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.genderBtn === 'all');
      });
    }
    document.querySelectorAll('.s-filter__panel input[type="checkbox"]').forEach(function(cb) {
      cb.checked = false;
    });
    // Remove AJAX grid and restore Load More
    var ajaxGrid = document.querySelector('[data-ajax-grid]');
    if (ajaxGrid) ajaxGrid.remove();
    if (grid) grid.style.display = '';
    var loadMoreWrap = document.querySelector('[data-load-more-wrap]');
    if (loadMoreWrap) loadMoreWrap.style.display = '';
    applyFilters();
    updateMoreBadge();
    updateMobileTags();
    updateMobileCount();
  }

  if (clearAllBtn) clearAllBtn.addEventListener('click', clearAllFilters);

  var clearAllTopBtn = document.querySelector('[data-clear-all-top]');
  if (clearAllTopBtn) clearAllTopBtn.addEventListener('click', clearAllFilters);

  // Clear buttons per filter
  document.querySelectorAll('[data-filter-clear]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = btn.getAttribute('data-filter-clear');
      document.querySelectorAll('input[name="filter_' + key + '"]').forEach(function(cb) {
        cb.checked = false;
      });
      applyFilters();
    });
  });

  // --- Petite/Short combo: sync hidden Short checkbox with visible Petite ---
  var petiteCb = document.querySelector('input[name="filter_length"][value="Petite"]');
  var hiddenShortCb = document.querySelector('[data-hidden-short]');
  function syncPetiteShort() {
    if (petiteCb && hiddenShortCb) {
      hiddenShortCb.checked = petiteCb.checked;
    }
  }

  // --- Checkbox change triggers filter ---
  document.querySelectorAll('.s-filter__panel input[type="checkbox"]').forEach(function(cb) {
    cb.addEventListener('change', function() {
      syncPetiteShort();
      applyFilters();
    });
  });

  // =====================================================================
  // MOBILE FILTER — Pills + Drawer
  // =====================================================================

  var mobileDrawer = document.querySelector('[data-filter-drawer]');
  var mobileDrawerBody = document.querySelector('[data-filter-drawer-body]');
  var mobileDrawerCount = document.querySelector('[data-filter-drawer-count]');
  var mobileDrawerOverlay = document.querySelector('[data-filter-drawer-overlay]');
  var mobileMoreCount = document.querySelector('[data-mobile-more-count]');
  var mobileMoreBtn = document.querySelector('[data-mobile-filter-open]');
  var savedScrollY = 0;

  // #296 T1.6: rebuild drawer when color-map.js finishes injecting color
  // checkboxes. Resolves the timing race where drawer opens before color
  // section is populated. Also re-run augmentation in case a new color name
  // unlocks a previously-unmapped family.
  document.addEventListener('ap:filter-color-ready', function() {
    if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
      buildDrawerBody();
    }
    if (_filterV2On) {
      runAugmentation(cards);
    }
  });

  // --- iOS-safe body scroll lock ---
  function lockBodyScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  // --- Drawer open/close ---
  function openDrawer() {
    if (!mobileDrawer) return;
    buildDrawerBody();
    mobileDrawer.classList.add('is-open');
    if (mobileDrawerOverlay) mobileDrawerOverlay.classList.add('is-open');
    lockBodyScroll();
    var closeBtn = mobileDrawer.querySelector('[data-filter-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    if (mobileDrawerOverlay) mobileDrawerOverlay.classList.remove('is-open');
    unlockBodyScroll();
    if (mobileMoreBtn) mobileMoreBtn.focus();
  }

  if (mobileMoreBtn) mobileMoreBtn.addEventListener('click', openDrawer);

  document.querySelectorAll('[data-filter-drawer-close]').forEach(function(btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (mobileDrawerOverlay) mobileDrawerOverlay.addEventListener('click', closeDrawer);

  var applyBtn = document.querySelector('[data-filter-drawer-apply]');
  if (applyBtn) applyBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth >= 768) {
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) closeDrawer();
      closeDropdown();
    }
  });

  // --- Focus trap inside drawer ---
  if (mobileDrawer) {
    mobileDrawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = mobileDrawer.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // --- Build drawer body from desktop filter panels + sort ---
  function buildDrawerBody() {
    if (!mobileDrawerBody) return;

    var html = '';

    // Gender section (only on non-gendered collections)
    if (genderContainer) {
      var genderOptions = ['all', 'women', 'men'];
      html += '<div class="s-filter__drawer-section"><div class="s-filter__drawer-section-title">Gender</div><div class="s-filter__drawer-section-body">';
      genderOptions.forEach(function(g) {
        var isActive = activeGender === g ? ' is-active' : '';
        var label = g.charAt(0).toUpperCase() + g.slice(1);
        html += '<button type="button" class="s-filter__drawer-opt' + isActive + '" data-drawer-gender="' + g + '">' + label + '</button>';
      });
      html += '</div></div>';
    }

    // Filter sections
    // W3 (#330 B9/S12): Product type + Length were missing entirely — mobile
    // users couldn't filter by either. The 'length' merge branch below was
    // dead code until Length joined this list.
    var sections = [
      { name: 'Product type', key: 'type', type: 'pills' },
      { name: 'Brand', key: 'brand', type: 'pills' },
      { name: 'Size', key: 'size', type: 'pills' },
      { name: 'Length', key: 'length', type: 'pills' },
      { name: 'Color', key: 'color', type: 'colors' },
      { name: 'Fabric', key: 'fabric', type: 'pills' },
      { name: 'Price', key: 'price', type: 'price' }
    ];

    sections.forEach(function(sec) {
      var desktopCheckboxes = document.querySelectorAll('.s-filter__panel input[name="filter_' + sec.key + '"]');
      if (desktopCheckboxes.length === 0) return;

      html += '<div class="s-filter__drawer-section"><div class="s-filter__drawer-section-title">' + sec.name + '</div><div class="s-filter__drawer-section-body">';

      if (sec.key === 'length') {
        // Merge Petite+Short into one button, keep Regular and Tall separate
        var petiteCb = document.querySelector('.s-filter__panel input[name="filter_length"][value="Petite"]');
        var shortCb = document.querySelector('.s-filter__panel input[name="filter_length"][value="Short"]');
        var petiteShortActive = (petiteCb && petiteCb.checked) || (shortCb && shortCb.checked) ? ' is-active' : '';
        var petiteUnavail = petiteCb && petiteCb.closest('[data-unavailable]');
        var shortUnavail = shortCb && shortCb.closest('[data-unavailable]');
        var psDimmed = (petiteUnavail && shortUnavail) ? ' is-dimmed' : '';
        html += '<button type="button" class="s-filter__drawer-opt' + petiteShortActive + psDimmed + '" data-drawer-combo="petite-short">Petite / Short</button>';

        desktopCheckboxes.forEach(function(cb) {
          if (cb.value === 'Petite' || cb.value === 'Short') return;
          var isChecked = cb.checked ? ' is-active' : '';
          var dimmed = cb.closest('[data-unavailable]') ? ' is-dimmed' : '';
          html += '<button type="button" class="s-filter__drawer-opt' + isChecked + dimmed + '" data-drawer-filter="' + sec.key + '" data-drawer-value="' + cb.value + '">' + cb.value + '</button>';
        });
      } else if (sec.type === 'colors') {
        desktopCheckboxes.forEach(function(cb) {
          var isChecked = cb.checked ? ' is-active' : '';
          var dimmed = cb.closest('[data-unavailable]') ? ' is-dimmed' : '';
          var labelEl = cb.closest('label');
          var swatch = labelEl ? labelEl.querySelector('.s-filter__color-swatch') : null;
          var bg = swatch ? swatch.style.cssText : 'background:#ccc';
          html += '<button type="button" class="s-filter__drawer-color-opt' + isChecked + dimmed + '" data-drawer-filter="' + sec.key + '" data-drawer-value="' + cb.value + '">';
          html += '<span class="s-filter__drawer-color-dot" style="' + bg + '"></span> ';
          html += cb.value + '</button>';
        });
      } else if (sec.type === 'price') {
        // #296 T6: use shared FACET_VALUE_LABELS instead of local priceLabels
        desktopCheckboxes.forEach(function(cb) {
          var isChecked = cb.checked ? ' is-active' : '';
          var dimmed = cb.closest('[data-unavailable]') ? ' is-dimmed' : '';
          var label = chipLabel('price', cb.value);
          html += '<button type="button" class="s-filter__drawer-opt' + isChecked + dimmed + '" data-drawer-filter="' + sec.key + '" data-drawer-value="' + cb.value + '">' + label + '</button>';
        });
      } else {
        desktopCheckboxes.forEach(function(cb) {
          var isChecked = cb.checked ? ' is-active' : '';
          var dimmed = cb.closest('[data-unavailable]') ? ' is-dimmed' : '';
          html += '<button type="button" class="s-filter__drawer-opt' + isChecked + dimmed + '" data-drawer-filter="' + sec.key + '" data-drawer-value="' + cb.value + '">' + cb.value + '</button>';
        });
      }

      html += '</div></div>';
    });

    mobileDrawerBody.innerHTML = html;

    // Gender button handlers
    mobileDrawerBody.querySelectorAll('[data-drawer-gender]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        activeGender = btn.dataset.drawerGender;
        // Sync desktop gender buttons
        if (genderContainer) {
          genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(b) {
            b.classList.toggle('is-active', b.dataset.genderBtn === activeGender);
          });
        }
        // Sync drawer gender buttons
        mobileDrawerBody.querySelectorAll('[data-drawer-gender]').forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.drawerGender === activeGender);
        });
        applyFilters();
        updateDrawerCount();
        updateMoreBadge();
        updateMobileTags();
      });
    });

    // Petite/Short combo button handler
    var comboBtn = mobileDrawerBody.querySelector('[data-drawer-combo="petite-short"]');
    if (comboBtn) {
      comboBtn.addEventListener('click', function() {
        var petiteCb = document.querySelector('.s-filter__panel input[name="filter_length"][value="Petite"]');
        var shortCb = document.querySelector('.s-filter__panel input[name="filter_length"][value="Short"]');
        var anyChecked = (petiteCb && petiteCb.checked) || (shortCb && shortCb.checked);
        if (petiteCb) petiteCb.checked = !anyChecked;
        if (shortCb) shortCb.checked = !anyChecked;
        comboBtn.classList.toggle('is-active', !anyChecked);
        applyFilters();
        updateDrawerCount();
        updateMoreBadge();
      });
    }

    // Filter button handlers
    mobileDrawerBody.querySelectorAll('[data-drawer-filter]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.drawerFilter;
        var value = btn.dataset.drawerValue;
        var desktopCb = document.querySelector('.s-filter__panel input[name="filter_' + key + '"][value="' + value + '"]');
        if (desktopCb) {
          desktopCb.checked = !desktopCb.checked;
          btn.classList.toggle('is-active', desktopCb.checked);
          applyFilters();
          updateDrawerCount();
          updateMoreBadge();
        }
      });
    });

    updateDrawerCount();
  }

  // --- Drawer count update ---
  // Shows the number of active filter selections in the "View (N)" footer button.
  // Counts all filter categories + gender. Petite/Short merged as 1.
  function updateDrawerCount() {
    if (!mobileDrawerCount) return;
    var drawerFilterKeys = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    var total = 0;
    drawerFilterKeys.forEach(function(key) {
      total += getCheckedValues(key).length;
    });
    if (activeGender !== 'all') total += 1;
    var lengthVals = getCheckedValues('length');
    if (lengthVals.indexOf('Petite') !== -1 && lengthVals.indexOf('Short') !== -1) {
      total -= 1;
    }
    mobileDrawerCount.textContent = String(total);
  }

  // --- "More" badge ---
  // Counts ALL active filters (gender + all checkbox categories) for the badge.
  function updateMoreBadge() {
    if (!mobileMoreCount || !mobileMoreBtn) return;
    var drawerFilterKeys = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    var total = 0;
    drawerFilterKeys.forEach(function(key) {
      total += getCheckedValues(key).length;
    });
    if (activeGender !== 'all') total += 1;
    // Petite + Short count as 1 selection, not 2
    var lengthVals = getCheckedValues('length');
    if (lengthVals.indexOf('Petite') !== -1 && lengthVals.indexOf('Short') !== -1) {
      total -= 1;
    }
    if (total > 0) {
      mobileMoreCount.textContent = total;
      mobileMoreCount.style.display = '';
      mobileMoreBtn.classList.add('is-active');
    } else {
      mobileMoreCount.style.display = 'none';
      mobileMoreBtn.classList.remove('is-active');
    }
  }

  // --- Drawer clear (header only; footer Clear replaced with Close in #105) ---
  var drawerHeaderClearBtn = document.querySelector('[data-filter-drawer-header-clear]');
  function handleDrawerClear() {
    clearAllFilters();
    buildDrawerBody();
  }
  if (drawerHeaderClearBtn) drawerHeaderClearBtn.addEventListener('click', handleDrawerClear);

  // --- Mobile product count ---
  var mobileCountEl = document.querySelector('[data-mobile-product-count]');
  function updateMobileCount() {
    if (!mobileCountEl || !countEl) return;
    var text = countEl.textContent || '';
    var match = text.match(/(\d+)/);
    mobileCountEl.textContent = match ? match[1] + ' items' : '';
  }

  // --- Mobile active filter tags ---
  var mobileTagsEl = document.querySelector('[data-mobile-tags]');
  function updateMobileTags() {
    if (!mobileTagsEl) return;
    var html = '';
    var hasAny = false;

    if (activeGender !== 'all') {
      hasAny = true;
      html += '<span class="s-filter__mobile-tag">' + activeGender.charAt(0).toUpperCase() + activeGender.slice(1) + '<button type="button" class="s-filter__mobile-tag-remove" data-mobile-tag-remove="gender">\u2715</button></span>';
    }

    var typeVals = getCheckedValues('type');
    typeVals.forEach(function(v) {
      hasAny = true;
      html += '<span class="s-filter__mobile-tag">' + v + '<button type="button" class="s-filter__mobile-tag-remove" data-mobile-tag-remove="type" data-mobile-tag-value="' + v + '">\u2715</button></span>';
    });

    var drawerKeys = ['brand', 'size', 'length', 'color', 'fabric'];
    drawerKeys.forEach(function(key) {
      var vals = getCheckedValues(key);
      vals.forEach(function(v) {
        hasAny = true;
        html += '<span class="s-filter__mobile-tag">' + v + '<button type="button" class="s-filter__mobile-tag-remove" data-mobile-tag-remove="' + key + '" data-mobile-tag-value="' + v + '">\u2715</button></span>';
      });
    });

    if (hasAny) {
      html += '<button type="button" class="s-filter__mobile-tags-clear" data-mobile-tags-clear>Clear all</button>';
    }

    mobileTagsEl.innerHTML = html;
    mobileTagsEl.style.display = hasAny ? '' : 'none';

    mobileTagsEl.querySelectorAll('[data-mobile-tag-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.mobileTagRemove;
        var value = btn.dataset.mobileTagValue;
        if (key === 'gender') {
          activeGender = 'all';
          if (genderContainer) {
            genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(b) {
              b.classList.toggle('is-active', b.dataset.genderBtn === 'all');
            });
          }
        } else {
          var cb = document.querySelector('input[name="filter_' + key + '"][value="' + value + '"]');
          if (cb) cb.checked = false;
        }
        applyFilters();
      });
    });

    var clearBtn = mobileTagsEl.querySelector('[data-mobile-tags-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        clearAllFilters();
      });
    }
  }

  // --- URL persistence ---

  function persistFiltersToURL() {
    var url = new URL(window.location.href);
    var filterTypes = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    filterTypes.forEach(function(ft) {
      var values = getCheckedValues(ft);
      if (values.length > 0) {
        url.searchParams.set(ft, values.join(','));
      } else {
        url.searchParams.delete(ft);
      }
    });
    if (activeGender !== 'all') {
      url.searchParams.set('gender', activeGender);
    } else {
      url.searchParams.delete('gender');
    }
    history.replaceState(null, '', url.toString());
  }

  function initializeFromURL() {
    var params = new URLSearchParams(window.location.search);
    var filterTypes = ['type', 'brand', 'size', 'length', 'color', 'fabric', 'price'];
    var hasFilters = false;

    filterTypes.forEach(function(ft) {
      var val = params.get(ft);
      if (val) {
        var values = val.split(',');
        values.forEach(function(v) {
          var cb = document.querySelector('input[name="filter_' + ft + '"][value="' + v + '"]');
          if (cb) { cb.checked = true; hasFilters = true; }
        });
      }
    });

    // Sync Petite/Short combo — if either was restored from URL, sync the other
    var _petite = document.querySelector('input[name="filter_length"][value="Petite"]');
    var _short = document.querySelector('[data-hidden-short]');
    if (_petite && _short) {
      if (_petite.checked && !_short.checked) _short.checked = true;
      if (_short.checked && !_petite.checked) _petite.checked = true;
    }

    var genderParam = params.get('gender');
    if (genderParam === 'women' || genderParam === 'men') {
      activeGender = genderParam;
      if (genderContainer) {
        genderContainer.querySelectorAll('[data-gender-btn]').forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.genderBtn === activeGender);
        });
      }
      hasFilters = true;
    }

    // Tag redirect: /collections/x/women → ?gender=women
    var pathParts = window.location.pathname.split('/');
    var lastPart = pathParts[pathParts.length - 1].toLowerCase();
    if (lastPart === 'women' || lastPart === "women's" || lastPart === 'men' || lastPart === "men's") {
      var gender = lastPart.replace("'s", '');
      var baseUrl = pathParts.slice(0, -1).join('/');
      window.location.replace(baseUrl + '?gender=' + gender);
      return;
    }

    if (hasFilters) applyFilters();
    updateMoreBadge();
    updateMobileTags();
    updateMobileCount();
  }

  // --- Mark cards hidden by color match so filters don't un-hide them ---
  // Run after initCollectionColorMatch has already hidden mismatched cards
  setTimeout(function() {
    cards.forEach(function(card) {
      if (card.style.display === 'none') {
        card.dataset.hiddenByColorMatch = 'true';
      }
    });
    // W2 (#330 B6): a throw inside restore must never silently skip checking
    // the remaining boxes — that left a restored filter half-applied.
    try { initializeFromURL(); }
    catch (e) { console.error('[filter] URL restore failed', e); }
    // Phase 1 cascading: scan DOM cards and hide dead-end filter options (#166)
    runCascading();
    _isInitialLoad = false;
  }, 50);

  // W2 (#330 B5): bfcache restore (back/forward) revives the page with frozen
  // JS state — possibly mid-loading or mid-error. Re-run the pipeline from the
  // (preserved) checkbox state so the customer sees settled results again.
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      cachedProducts = null; // stale-safe: refetch rather than trust frozen cache
      applyFilters();
    }
  });

  // #224: When server-side Load More appends new cards, re-apply any active
  // filters so the new cards respect the current filter state.
  document.addEventListener('loadmore:complete', function() {
    if (hasAnyFilter()) applyFilters();
  });
}

// =====================================================================
// LOAD MORE — Collection pagination
// =====================================================================
(function initLoadMore() {
  var btn = document.querySelector('[data-load-more]');
  if (!btn) return;

  btn.addEventListener('click', function() {
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    btn.classList.add('is-loading');
    btn.textContent = 'LOADING...';

    fetch(nextUrl)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Extract product cards from the fetched page
        var newGrid = doc.querySelector('[data-product-grid]');
        var grid = document.querySelector('[data-product-grid]');
        if (newGrid && grid) {
          var cards = newGrid.children;
          while (cards.length > 0) {
            grid.appendChild(cards[0]);
          }
        }

        // Check if there's another page
        var newBtn = doc.querySelector('[data-load-more]');
        if (newBtn) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.classList.remove('is-loading');
          btn.textContent = 'LOAD MORE';
        } else {
          // No more pages — hide button
          btn.closest('[data-load-more-wrap]').style.display = 'none';
        }

        // Re-initialize color swatches on new cards
        if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) {
          AP_COLOR_MAP.applyAll();
        }

        // #224: Re-run color collection matching for newly appended cards.
        // initCollectionColorMatch() only runs on initial page load, so page 2+
        // cards show their default color (usually Black) instead of the
        // collection's color (e.g. Navy on /collections/navy-scrubs).
        // Re-running it re-queries all cards and swaps images/swatches for
        // any new cards that weren't in the DOM on first run.
        if (typeof initCollectionColorMatch === 'function') {
          initCollectionColorMatch();
        }

        // #224: Notify filter system that new cards were appended so it can
        // re-query its card list and re-apply any active filters.
        document.dispatchEvent(new CustomEvent('loadmore:complete'));
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.textContent = 'LOAD MORE';
      });
  });
})();

/* Mobile filter pills (Women/Men/Tops/Pants...) */ document.addEventListener('DOMContentLoaded', function () { var wrap = document.querySelector('.s-filter__mobile-pills'); if (!wrap) return; function gBtn(v) { return [].slice.call(document.querySelectorAll('[data-gender-btn]')).filter(function (b) { return b.dataset.genderBtn === v; })[0]; } function cbFor(k, v) { return [].slice.call(document.querySelectorAll('input[name=filter_' + k + ']')).filter(function (c) { return c.value === v; })[0]; } function activeG() { var g = document.querySelector('[data-gender-btn].is-active'); return g ? g.dataset.genderBtn : 'all'; } function sync() { wrap.querySelectorAll('[data-mobile-pill]').forEach(function (p) { var on; if (p.dataset.mobilePill === 'gender') { on = p.dataset.value === activeG(); } else { var c = cbFor(p.dataset.mobilePill, p.dataset.value); on = !!(c && c.checked); } p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); }); } wrap.querySelectorAll('[data-mobile-pill]').forEach(function (p) { p.addEventListener('click', function () { var k = p.dataset.mobilePill, v = p.dataset.value; if (k === 'gender') { var b = gBtn(activeG() === v ? 'all' : v); if (b) b.click(); } else { var c = cbFor(k, v); if (c) { c.checked = !c.checked; c.dispatchEvent(new Event('change', { bubbles: true })); } } setTimeout(sync, 50); }); }); document.addEventListener('change', function () { setTimeout(sync, 50); }); document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-gender-btn],[data-drawer-gender],[data-drawer-filter],[data-mobile-tag-remove],[data-mobile-tags-clear]')) setTimeout(sync, 50); }); setTimeout(sync, 300); });
/* Daily shuffle: SALE 70% OFF collection (new order each day, same for everyone that day) */ document.addEventListener('DOMContentLoaded', function () { if (['/collections/sale-up-to-70-off', (window.AP_STORE && AP_STORE.code === 'US') ? '/collections/sale' : ''].indexOf(window.location.pathname.replace(/\/$/, '')) < 0 || window.location.search) return; var grid = document.querySelector('[data-product-grid]'); if (!grid) return; var btn = document.querySelector('[data-load-more]'); var next = btn ? btn.getAttribute('data-next-url') : null; var pages = 1; grid.style.transition = 'opacity .2s'; grid.style.opacity = '0'; var failsafe = setTimeout(function () { grid.style.opacity = ''; }, 4000); function loadNext() { if (!next || pages >= 20) return Promise.resolve(); return fetch(next).then(function (r) { return r.text(); }).then(function (html) { var doc = new DOMParser().parseFromString(html, 'text/html'); var ng = doc.querySelector('[data-product-grid]'); if (ng) { while (ng.children.length) grid.appendChild(ng.children[0]); } var nb = doc.querySelector('[data-load-more]'); next = nb ? nb.getAttribute('data-next-url') : null; pages++; return loadNext(); }); } loadNext().then(function () { var d = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' }); var s = 0; for (var i = 0; i < d.length; i++) s = (s * 31 + d.charCodeAt(i)) >>> 0; function rnd() { s = (s + 0x6D2B79F5) >>> 0; var t = s; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; } var cards = [].slice.call(grid.children); for (var k = cards.length - 1; k > 0; k--) { var j = Math.floor(rnd() * (k + 1)); var tmp = cards[k]; cards[k] = cards[j]; cards[j] = tmp; } cards.forEach(function (c) { grid.appendChild(c); }); var w = document.querySelector('[data-load-more-wrap]'); if (w) w.style.display = 'none'; if (typeof AP_COLOR_MAP !== 'undefined' && AP_COLOR_MAP.applyAll) AP_COLOR_MAP.applyAll(); if (typeof initCollectionColorMatch === 'function') initCollectionColorMatch(); document.dispatchEvent(new CustomEvent('loadmore:complete')); }).catch(function () {}).then(function () { clearTimeout(failsafe); grid.style.opacity = ''; }); });
/* Promo terms: Buy 3 Get 1 vs 200+ bulk (not combinable) */ (function () { var SALE = (window.AP_STORE && AP_STORE.code === 'US') ? '/collections/sale' : '/collections/sale-up-to-70-off'; var CSS = '.apx-offers{display:none!important;margin:16px 0;padding:14px 16px;border:1px solid #e3ded8;border-left:4px solid #b3261e;background:#faf8f6;border-radius:6px;font-size:14px;line-height:1.45;color:#1a1a1a;box-sizing:border-box}.apx-grid{display:grid;grid-template-columns:1fr;gap:16px}.apx-offer b{display:block;font-size:14px;letter-spacing:.03em}.apx-offer span{display:block;margin-top:2px}.apx-offer small{display:block;margin-top:5px;font-size:12px;color:#5a5a5a}.apx-or{margin-top:10px;padding-top:8px;border-top:1px dashed #d8d2cc;font-size:12px;font-weight:700;text-align:center;letter-spacing:.02em}.apx-cartmsg{margin:12px 0;padding:12px 14px;border-radius:6px;background:#faf8f6;border:1px solid #e3ded8;border-left:4px solid #b3261e;font-size:13px;line-height:1.45;color:#1a1a1a}.apx-cartmsg.is-bulk{background:#eef7ef;border-color:#9cc9a1;border-left-color:#2e7d32}.apx-cartmsg b{display:block;font-size:14px}.apx-cartmsg small{display:block;margin-top:4px;font-size:12px;color:#5a5a5a}.apx-cartmsg[hidden]{display:none}.s-pdp__info .apx-grid{grid-template-columns:1fr;gap:10px}@media (max-width:749px){.apx-grid{grid-template-columns:1fr;gap:10px}.apx-offers{display:none!important;margin:12px 0;padding:12px;font-size:13px}.apx-offer b{font-size:13px}}'; function css() { if (document.getElementById('apx-css')) return; var s = document.createElement('style'); s.id = 'apx-css'; s.textContent = CSS; document.head.appendChild(s); } function offers() { var d = document.createElement('div'); d.className = 'apx-offers'; d.setAttribute('data-apx', '1'); d.innerHTML = '<div class=apx-grid><div class=apx-offer><b>BUY 200+ SALE ITEMS &amp; GET 40% OFF</b><span>Mix &amp; match eligible sale styles, colours and sizes.</span><small>Cannot be combined with other offers.</small></div></div>'; return d; } function saleIds() { try { var c = JSON.parse(sessionStorage.getItem('apxSale') || 'null'); if (c && Date.now() - c.t < 1800000) return Promise.resolve(c.ids); } catch (e) {} var ids = {}; function page(n) { return fetch(SALE + '/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) { (j.products || []).forEach(function (p) { p.variants.forEach(function (v) { ids[v.id] = 1; }); }); if ((j.products || []).length === 250 && n < 8) return page(n + 1); }); } return page(1).then(function () { try { sessionStorage.setItem('apxSale', JSON.stringify({ t: Date.now(), ids: ids })); } catch (e) {} return ids; }); } function cartState() { return Promise.all([saleIds(), fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (a) { var ids = a[0], n = 0, bulk = false; a[1].items.forEach(function (i) { if (ids[i.variant_id]) n += i.quantity; (i.line_level_discount_allocations || []).forEach(function (x) { if (/WHOLESALE/i.test((x.discount_application && x.discount_application.title) || '')) bulk = true; }); }); return { n: n, bulk: bulk }; }); } function msg(s) { var cnt = '<small>' + s.n + ' eligible sale item' + (s.n === 1 ? '' : 's') + ' in your cart.</small>'; if (s.n >= 200) return s.bulk ? '<b>' + (s.n >= 500 ? 50 : 40) + '% Bulk Discount Applied</b><small>Your ' + (s.n >= 500 ? '500+' : '200+') + ' sale item order gets ' + (s.n >= 500 ? 50 : 40) + '% off.' + (s.n < 500 ? ' Add ' + (500 - s.n) + ' more for 50% off.' : ' Ordering more? Email info@ap-uniforms.com and we’ll see what we can do.') + ' Cannot be combined with other offers.</small>' + cnt : '<b>Your order qualifies for ' + (s.n >= 500 ? 50 : 40) + '% bulk pricing</b><small>Bulk pricing is applied at checkout. Cannot be combined with other offers.</small>' + cnt; if (s.n >= 100) return 'Order 200+ sale items to unlock bulk pricing: 40% off at 200+, 50% at 500+.' + cnt; if (s.n >= 100) return 'Order 200+ sale items to unlock bulk pricing: 40% off at 200+, 50% at 500+.' + cnt; return ''; } function box(parent, before) { var b = parent.querySelector('.apx-cartmsg'); if (!b) { b = document.createElement('div'); b.className = 'apx-cartmsg'; b.hidden = true; if (before && before.parentNode) before.parentNode.insertBefore(b, before); else parent.insertBefore(b, parent.firstChild); } return b; } function paint(b) { return cartState().then(function (s) { var h = msg(s); b.hidden = !h; b.classList.toggle('is-bulk', s.n >= 200); if (b.getAttribute('data-h') !== h) { b.innerHTML = h; b.setAttribute('data-h', h); } }).catch(function () {}); } function watch(root, fn) { var t; new MutationObserver(function (ms) { if (ms.every(function (m) { return m.target.closest && m.target.closest('.apx-cartmsg'); })) return; clearTimeout(t); t = setTimeout(fn, 500); }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] }); } function cartPage() { var sec = document.querySelector('.s-cart'); if (!sec) return; function run() { var hdr = sec.querySelector('.s-cart__header'); var b = box(sec.querySelector('.container') || sec, hdr ? hdr.nextSibling : null); paint(b); } run(); watch(sec, run); } function drawer() { var d = document.querySelector('[data-cart-drawer]'); if (!d) return; function run() { var main = d.querySelector('.s-cart-drawer__main') || d; var sub = d.querySelector('.s-cart-drawer__subtotal'); paint(box(main, sub)); } run(); watch(d, run); } function place() { if (false && !document.querySelector('.apx-strip')) { var hd = document.querySelector('header'); var hw = hd && (hd.closest('.shopify-section') || hd); if (hw && hw.parentNode) { var st = document.createElement('div'); st.className = 'apx-strip'; st.style.cssText = 'background:#faf8f6;border-bottom:1px solid #e3ded8;color:#1a1a1a;text-align:center;font-size:13px;line-height:1.45;padding:8px 16px;'; st.innerHTML = '<b>40% OFF 200+ sale items</b> <span style=color:#5a5a5a>— wholesale pricing. <a href=/pages/wholesale style=color:inherit;text-decoration:underline>Details</a></span>'; hw.parentNode.insertBefore(st, hw.nextSibling); } } return; var p = location.pathname.replace(/\/$/, '') || '/'; if (p === SALE) { var g = document.querySelector('[data-product-grid]'); var anchor = g && (g.closest('.s-collection__grid-wrap') || g); if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(offers(), anchor); } else if (p === '/') { var hero = document.querySelector('main .shopify-section[id*=hero_banner]') || document.querySelector('main .shopify-section'); if (hero) { var w = document.createElement('div'); w.className = 'container'; w.appendChild(offers()); hero.parentNode.insertBefore(w, hero.nextSibling); } } else if (p === '/pages/wholesale') { var h = document.querySelector('main h1'); if (h) h.parentNode.insertBefore(offers(), h.nextSibling); } else if (/\/products\//.test(p)) { var fs = document.querySelector('.s-pdp__final-sale') || document.querySelector('form[action*="/cart/add"]'); if (!fs) return; Promise.all([saleIds(), fetch(p + '.js').then(function (r) { return r.json(); })]).then(function (a) { if (a[1].variants.some(function (v) { return a[0][v.id]; })) fs.parentNode.insertBefore(offers(), fs.nextSibling); }).catch(function () {}); } } function init() { css(); place(); cartPage(); drawer(); } if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); })();
